import React, { useState, useEffect, useRef } from 'react';
import { getDatabase, ref, push, set, onValue, get, update } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import emailjs from 'emailjs-com';
import { useParams, useNavigate } from 'react-router-dom';
import './Pendientes.css';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// Inicializar EmailJS (solo es necesario una vez, pero seguro si se llama varias veces)
emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);

// Función auxiliar para enviar correo
const enviarCorreoCambio = async ({ tipo, publicacion, comentario = null, anterior = null }) => {
    const emailServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    if (!emailServiceId) {
        console.warn('REACT_APP_EMAILJS_SERVICE_ID no esta configurado.');
        return;
    }

    const now = new Date();
    const fechaHora = now.toLocaleString('es-AR');
    let subject = '';
    let message = '';
    const usuario = (comentario?.autor || publicacion?.autor || {}).email || 'Usuario desconocido';
    const nombre = (comentario?.autor || publicacion?.autor || {}).nombre || '';
    const nombreUsuario = nombre ? `${nombre} (${usuario})` : usuario;
    const id = publicacion.id || '-';
    const estadoAnterior = anterior?.estado || publicacion?.estado || '-';
    const estadoNuevo = publicacion?.estado || '-';
    const textoAnterior = anterior?.contenido || '';
    const textoNuevo = publicacion?.contenido || '';

    switch (tipo) {
        case 'comentario':
            subject = `Nuevo comentario en publicación (ID: ${id})`;
            message = `Acción: Nuevo comentario\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nComentario:\n"${comentario?.texto}"\n\nTexto de la publicación:\n"${textoNuevo}"`;
            break;
        case 'confirmado':
            subject = `Publicación confirmada (ID: ${id})`;
            message = `Acción: Confirmar publicación\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nEstado anterior: ${estadoAnterior}\nEstado nuevo: ${estadoNuevo}\n\nTexto de la publicación:\n"${textoNuevo}"`;
            break;
        case 'rechazado':
            subject = `Publicación rechazada (ID: ${id})`;
            message = `Acción: Rechazar publicación\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nEstado anterior: ${estadoAnterior}\nEstado nuevo: ${estadoNuevo}\n\nTexto de la publicación:\n"${textoNuevo}"`;
            break;
        case 'borrado':
            subject = `Publicación borrada (ID: ${id})`;
            message = `Acción: Borrar publicación\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nEstado anterior: ${estadoAnterior}\nEstado nuevo: ${estadoNuevo}\n\nTexto de la publicación:\n"${textoNuevo}"`;
            break;
        case 'editado':
            subject = `Publicación editada (ID: ${id})`;
            message = `Acción: Editar publicación\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nTexto anterior:\n"${textoAnterior}"\n\nTexto nuevo:\n"${textoNuevo}"`;
            break;
        case 'pendiente':
            subject = `Publicación marcada como pendiente (ID: ${id})`;
            message = `Acción: Marcar como pendiente\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nEstado anterior: ${estadoAnterior}\nEstado nuevo: ${estadoNuevo}\n\nTexto de la publicación:\n"${textoNuevo}"`;
            break;
        case 'ausente':
            subject = `Publicación marcada como ausente (ID: ${id})`;
            message = `Acción: Marcar como ausente\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nEstado anterior: ${estadoAnterior}\nEstado nuevo: ${estadoNuevo}\n\nTexto de la publicación:\n"${textoNuevo}"`;
            break;
        default:
            subject = `Cambio en publicación (ID: ${id})`;
            message = `Acción: Cambio desconocido\nID de publicación: ${id}\nUsuario: ${nombreUsuario}\nFecha/Hora: ${fechaHora}\n\nTexto de la publicación:\n"${textoNuevo}"`;
    }
    try {
        await emailjs.send(emailServiceId, "template_cn46vzz", {
            email: "benitez.gino48@gmail.com",
            subject,
            message
        });
    } catch (error) {
        console.error('Error al enviar correo:', error);
    }
};

function Pendientes({ isAdmin, isPublicador, actualizarPublicacionesNoVistas }) {
    const { publicacionId } = useParams();
    const navigate = useNavigate();
    const [publicaciones, setPublicaciones] = useState([]);
    const [nuevaPublicacion, setNuevaPublicacion] = useState({
        texto: '',
        fechaPublicacion: '',
        horaPublicacion: '',
        contenidoUrl: '',
        urlsImagenes: [],
        tipoContenido: 'texto',
        tipo: 'todas',
        estado: 'confirmado'
    });
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [selectedPublicacion, setSelectedPublicacion] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editedPublicacion, setEditedPublicacion] = useState(null);
    const [tipoSeleccionado, setTipoSeleccionado] = useState('todas');
    const [showPastPublications, setShowPastPublications] = useState(false);
    const [vistasPublicaciones, setVistasPublicaciones] = useState({});
    const [vistasDetalle, setVistasDetalle] = useState({});
    const [usuarios, setUsuarios] = useState({});
    const [historialExpandido, setHistorialExpandido] = useState(false);
    // Estado para mostrar/ocultar detalles extra en el modal

    // Estado para mostrar/ocultar la sección de vistos por
    const [vistosPorExpandido, setVistosPorExpandido] = useState(false);
    // Ref para el scroll del modal
    const modalContentRef = useRef(null);
    // Ref para guardar la posición del scroll
    const scrollPositionRef = useRef(0);
    // Ref para controlar si se debe restaurar el scroll
    const shouldRestoreScroll = useRef(false);

    const auth = getAuth(app);

    // Estado local para el campo de texto de edición

    // Ref para el textarea de edición
    const contenidoEditadoRef = useRef(null);
    // Ref para el input de URL de edición
    const urlEditadaRef = useRef(null);
    // Refs para los inputs de fecha y hora en edición
    const fechaEditadaRef = useRef(null);
    const horaEditadaRef = useRef(null);
    const indefinidoEditadaRef = useRef(null);

    // Estado local para feedback de copiado
    const [copied, setCopied] = useState(false);
    // Estado para mensajes de confirmación visual
    const [mensajeConfirmacion, setMensajeConfirmacion] = useState('');

    // Estado para la vista previa de archivos (Drive o normales)
    const [previewFile, setPreviewFile] = useState(null); // { url, tipoContenido }

    // Estado para el filtro de fecha
    const [fechaFiltro, setFechaFiltro] = useState(''); // Fecha seleccionada para filtrar

    // Estados para drag and drop y Cloudinary
    const [isDragOver, setIsDragOver] = useState(false);
    const [uploadingFiles, setUploadingFiles] = useState([]);

    const fileInputRef = useRef(null);

    // Pagination state for lazy loading date groups
    const [visibleDatesCount, setVisibleDatesCount] = useState(5);
    const DATES_PER_PAGE = 5;

    // --- MANEJO DEL BOTÓN DE ATRÁS (HISTORY API) ---
    // Ref para acceder al estado actual dentro del listener de popstate
    const showModalRef = useRef(showModal);

    // Mantener ref actualizado
    useEffect(() => { showModalRef.current = showModal; }, [showModal]);

    // Efecto para controlar la navegación y el botón de atrás
    useEffect(() => {
        // Empujar un estado inicial para poder interceptar el primer "atrás" y confirmar salida
        window.history.pushState({ type: 'main' }, '', window.location.href);

        const handlePopState = (event) => {
            // Prioridad 1: Si el Modal está abierto, cerrarlo
            if (showModalRef.current) {
                // El evento de atrás YA ocurrió (se removió 'modal' del stack)
                setShowModal(false);
                showModalRef.current = false;
                return;
            }

            // Prioridad 2: Si estamos en la vista principal, confirmar salida
            // Como ya ocurrió el popstate, estamos "saliendo" o volviendo a la página anterior real.
            // Si el usuario cancela, debemos volver a empujar el estado "main" para quedarnos.
            if (!window.confirm("¿Deseas salir de la sección de Publicaciones?")) {
                // El usuario quiere quedarse
                window.history.pushState({ type: 'main' }, '', window.location.href);
            } else {
                // El usuario confirmó salir. navegamos hacia atrás.
                window.history.back(); // Forzamos ir hacia atrás. Si no hay historial, en PWA Android suele cerrar la app o fallback de router.
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []); // Se ejecuta solo al montar

    // Efecto para empujar estado al abrir Modal
    useEffect(() => {
        if (showModal) {
            window.history.pushState({ type: 'modal' }, '', window.location.href);
        }
    }, [showModal]);





    // --- useEffect para compartir publicación directo (deben ir aquí­, antes de cualquier función interna o return) ---
    useEffect(() => {
        if (publicacionId && publicaciones.length > 0) {
            const pub = publicaciones.find(p => p.id === publicacionId);
            if (pub) {
                setSelectedPublicacion(pub);
                setShowModal(true);
            }
        }
    }, [publicacionId, publicaciones]);

    useEffect(() => {
        if (publicacionId && !auth.currentUser) {
            localStorage.setItem('pendingPublicacionId', publicacionId);
        }
    }, [publicacionId, auth.currentUser]);

    useEffect(() => {
        if (auth.currentUser) {
            const pendingId = localStorage.getItem('pendingPublicacionId');
            if (pendingId) {
                localStorage.removeItem('pendingPublicacionId');
                navigate(`/pendientes/${pendingId}`, { replace: true });
            }
        }
    }, [auth.currentUser, navigate]);


    useEffect(() => {
        try {
            const publicacionesRef = ref(database, 'Publicaciones');
            const unsubscribe = onValue(publicacionesRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    const publicacionesArray = Object.entries(data).map(([id, pub]) => ({
                        id,
                        ...pub,
                        comentarios: pub.comentarios || {},
                        estado: pub.estado || 'pendiente'
                    }));
                    setPublicaciones(publicacionesArray.sort((a, b) =>
                        new Date(b.fecha) - new Date(a.fecha)
                    ));
                } else {
                    setPublicaciones([]);
                }
                setLoading(false);
            }, (error) => {
                console.error('Error al cargar publicaciones:', error);
                setLoading(false);
            });

            return () => unsubscribe();
        } catch (error) {
            console.error('Error al inicializar Firebase:', error);
            setLoading(false);
        }
    }, []);

    // Agregar useEffect para cargar las vistas del usuario
    useEffect(() => {
        if (auth.currentUser) {
            const vistasRef = ref(database, `VistasPublicaciones/${auth.currentUser.uid}`);
            const unsubscribe = onValue(vistasRef, (snapshot) => {
                const data = snapshot.val();
                setVistasPublicaciones(data || {});
            });

            return () => unsubscribe();
        }
    }, [auth.currentUser]);

    // Agregar useEffect para verificar si hay publicaciones no vistas
    useEffect(() => {
        if (!auth.currentUser) {
            actualizarPublicacionesNoVistas(false);
            return;
        }

        // Si no hay publicaciones, no hay nada que verificar
        if (publicaciones.length === 0) {
            actualizarPublicacionesNoVistas(false);
            return;
        }

        // Verificar si todas las publicaciones relevantes han sido vistas
        // Solo cuentan publicaciones de HOY en adelante (no pasadas)
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const publicacionesRelevantes = publicaciones.filter(pub => {
            // Excluir publicaciones con fecha pasada
            if (pub.fechaPublicacion && pub.fechaPublicacion !== 'indefinido' && pub.fechaPublicacion !== '') {
                const fechaPub = new Date(pub.fechaPublicacion + 'T00:00:00');
                if (fechaPub < today) return false;
            }
            return isAdmin || isPublicador || pub.estado === 'confirmado';
        });

        // Si no hay publicaciones relevantes, no hay nada que verificar
        if (publicacionesRelevantes.length === 0) {
            actualizarPublicacionesNoVistas(false);
            return;
        }

        // Verificar si todas las publicaciones relevantes han sido vistas
        const todasVistas = publicacionesRelevantes.every(pub => {
            const vista = vistasPublicaciones[pub.id];
            if (!vista) {
                return false;
            }

            const ultimaVista = new Date(vista.ultimaVista);
            const ultimaActualizacion = new Date(vista.ultimaActualizacion);

            // Verificar si hay nuevos comentarios
            const comentarios = pub.comentarios || {};
            const hayNuevosComentarios = Object.values(comentarios).some(
                comentario => new Date(comentario.fecha) > ultimaVista
            );

            // Verificar si hubo cambios en el estado o en la publicación
            const huboCambios = ultimaActualizacion > ultimaVista;

            return !hayNuevosComentarios && !huboCambios;
        });

        actualizarPublicacionesNoVistas(!todasVistas);
    }, [publicaciones, vistasPublicaciones, auth.currentUser, isAdmin, isPublicador, actualizarPublicacionesNoVistas]);

    // Marcar automáticamente como vistas las publicaciones de hoy/futuras al mostrarse en la lista
    useEffect(() => {
        if (!auth.currentUser || publicaciones.length === 0) return;

        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);

        const publicacionesAMarcar = publicaciones.filter(pub => {
            // Solo publicaciones de hoy en adelante o indefinidas
            if (pub.fechaPublicacion && pub.fechaPublicacion !== 'indefinido' && pub.fechaPublicacion !== '') {
                const fechaPub = new Date(pub.fechaPublicacion + 'T00:00:00');
                if (fechaPub < todayStart) return false; // Saltar pasadas
            }
            // Solo las que el usuario puede ver
            if (!isAdmin && !isPublicador && pub.estado !== 'confirmado') return false;
            // Solo marcar si aún no está vista o tiene cambios
            return tieneCambiosNoVistos(pub);
        });

        if (publicacionesAMarcar.length === 0) return;

        const now = new Date().toISOString();
        const db = getDatabase();
        publicacionesAMarcar.forEach(async (pub) => {
            try {
                const vistasRef = ref(db, `VistasPublicaciones/${auth.currentUser.uid}/${pub.id}`);
                await set(vistasRef, {
                    ultimaVista: now,
                    ultimaActualizacion: pub.fecha || now
                });
            } catch (e) {
                // silenciar errores individuales de escritura
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [publicaciones, auth.currentUser, isAdmin, isPublicador]);

    // Agregar useEffect para cargar las vistas detalladas
    useEffect(() => {
        if (auth.currentUser && (isAdmin || isPublicador)) {
            const vistasRef = ref(database, 'VistasPublicaciones');
            const unsubscribe = onValue(vistasRef, (snapshot) => {
                const data = snapshot.val();
                setVistasDetalle(data || {});
            });

            return () => unsubscribe();
        }
    }, [auth.currentUser, isAdmin, isPublicador]);

    // Agregar useEffect para cargar los usuarios
    useEffect(() => {
        if (auth.currentUser && (isAdmin || isPublicador)) {
            const usuariosRef = ref(database, 'Publicador');
            const adminRef = ref(database, 'Administrador');
            const normalUsersRef = ref(database, 'Empleado');

            const unsubscribePublicadores = onValue(usuariosRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setUsuarios(prev => ({ ...prev, ...data }));
                }
            });

            const unsubscribeAdmins = onValue(adminRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setUsuarios(prev => ({ ...prev, ...data }));
                }
            });

            const unsubscribeNormal = onValue(normalUsersRef, (snapshot) => {
                const data = snapshot.val();
                if (data) {
                    setUsuarios(prev => ({ ...prev, ...data }));
                }
            });

            return () => {
                unsubscribePublicadores();
                unsubscribeAdmins();
                unsubscribeNormal();
            };
        }
    }, [auth.currentUser, isAdmin, isPublicador]);

    const obtenerEmailUsuario = (userId) => {
        // Si el usuario está en nuestra lista de usuarios, usar su email
        if (usuarios[userId]?.email) {
            return usuarios[userId].email;
        }
        // Si no, intentar obtener el email del autor de la publicación
        if (selectedPublicacion?.autor?.uid === userId) {
            return selectedPublicacion.autor.email;
        }
        // Si aíºn no tenemos el email, mostrar el ID
        return userId;
    };

    const obtenerVistasPublicacion = (publicacionId) => {
        if (!vistasDetalle) return [];

        const vistas = [];
        Object.entries(vistasDetalle).forEach(([userId, userVistas]) => {
            if (userVistas[publicacionId]) {
                vistas.push({
                    userId,
                    ultimaVista: userVistas[publicacionId].ultimaVista,
                    ultimaActualizacion: userVistas[publicacionId].ultimaActualizacion
                });
            }
        });

        return vistas.sort((a, b) => new Date(b.ultimaVista) - new Date(a.ultimaVista));
    };



    const getDriveFileId = (url) => {
        try {
            // Maneja diferentes formatos de URLs de Google Drive
            if (url.includes('drive.google.com/file/d/')) {
                return url.split('/file/d/')[1].split('/')[0];
            } else if (url.includes('drive.google.com/open?id=')) {
                return url.split('open?id=')[1];
            } else if (url.includes('drive.google.com/uc?id=')) {
                return url.split('uc?id=')[1];
            } else if (url.includes('drive.google.com/uc?export=view&id=')) {
                return url.split('uc?export=view&id=')[1];
            } else if (url.includes('thumbnail?id=')) {
                return url.split('thumbnail?id=')[1].split('&')[0];
            }
            return null;
        } catch (error) {
            console.error('Error al extraer ID de Drive:', error);
            return null;
        }
    };

    const getDriveThumbnail = (fileId) => {
        return `https://drive.google.com/thumbnail?id=${fileId}&sz=w800`;
    };



    // Función para subir archivos a Cloudinary
    const uploadToCloudinary = async (file, onProgress) => {
        try {
            const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
            const uploadPreset = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

            if (!cloudName || !uploadPreset) {
                throw new Error('Cloudinary no esta configurado.');
            }

            const formData = new FormData();
            formData.append('file', file);
            formData.append('upload_preset', uploadPreset);
            formData.append('folder', 'pendiente');

            // Generar un nombre único para el archivo
            const timestamp = Date.now();
            const fileName = `${timestamp}_${file.name.replace(/[^a-zA-Z0-9.]/g, '_')}`;
            formData.append('public_id', fileName.replace(/\.[^/.]+$/, ''));

            const response = await fetch(
                `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
                {
                    method: 'POST',
                    body: formData
                }
            );

            if (!response.ok) {
                throw new Error('Error al subir archivo a Cloudinary');
            }

            const data = await response.json();
            return data.secure_url;
        } catch (error) {
            console.error('Error uploading to Cloudinary:', error);
            throw error;
        }
    };

    // Función para manejar archivos seleccionados o arrastrados
    const handleFiles = async (files) => {
        const fileArray = Array.from(files);
        const validFiles = fileArray.filter(file => {
            const isImage = file.type.startsWith('image/');
            const isVideo = file.type.startsWith('video/');
            return isImage || isVideo;
        });

        if (validFiles.length === 0) {
            alert('Por favor selecciona solo archivos de imagen o video.');
            return;
        }

        setUploadingFiles(validFiles.map(file => ({ file, status: 'uploading' })));

        const uploadPromises = validFiles.map(async (file, index) => {
            try {
                const url = await uploadToCloudinary(file, (progress) => {
                });

                setUploadingFiles(prev =>
                    prev.map((item, i) =>
                        i === index ? { ...item, status: 'completed', url } : item
                    )
                );

                return url;
            } catch (error) {
                setUploadingFiles(prev =>
                    prev.map((item, i) =>
                        i === index ? { ...item, status: 'error', error: error.message } : item
                    )
                );
                return null;
            }
        });

        const uploadedUrls = await Promise.all(uploadPromises);
        const successfulUrls = uploadedUrls.filter(url => url !== null);

        if (successfulUrls.length > 0) {
            setNuevaPublicacion(prev => ({
                ...prev,
                urlsImagenes: [...prev.urlsImagenes, ...successfulUrls]
            }));
        }

        // Limpiar estados después de 3 segundos
        setTimeout(() => {
            setUploadingFiles([]);
        }, 3000);
    };

    // Función para manejar archivos en modo edición
    const handleEditFiles = async (files) => {
        const fileArray = Array.from(files);
        const validFiles = fileArray.filter(file => {
            const isImage = file.type.startsWith('image/');
            const isVideo = file.type.startsWith('video/');
            return isImage || isVideo;
        });

        if (validFiles.length === 0) {
            alert('Por favor selecciona solo archivos de imagen o video.');
            return;
        }

        // Usamos el mismo estado de uploadingFiles para mostrar progreso en el modal
        setUploadingFiles(validFiles.map(file => ({ file, status: 'uploading' })));

        const uploadPromises = validFiles.map(async (file, index) => {
            try {
                const url = await uploadToCloudinary(file);

                setUploadingFiles(prev =>
                    prev.map((item, i) =>
                        i === index ? { ...item, status: 'completed', url } : item
                    )
                );

                return url;
            } catch (error) {
                setUploadingFiles(prev =>
                    prev.map((item, i) =>
                        i === index ? { ...item, status: 'error', error: error.message } : item
                    )
                );
                return null;
            }
        });

        const uploadedUrls = await Promise.all(uploadPromises);
        const successfulUrls = uploadedUrls.filter(url => url !== null);

        if (successfulUrls.length > 0) {
            setEditedPublicacion(prev => ({
                ...prev,
                urlsImagenes: [...(prev.urlsImagenes || []), ...successfulUrls]
            }));
        }

        // Limpiar estados después de 3 segundos
        setTimeout(() => {
            setUploadingFiles([]);
        }, 3000);
    };

    // Manejadores de drag and drop
    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const files = e.dataTransfer.files;
        handleFiles(files);
    };

    // Manejador para input de archivos
    const handleFileInputChange = (e) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            handleFiles(files);
        }
    };

    // Función para determinar si una URL es de Cloudinary
    const isCloudinaryUrl = (url) => {
        return url && url.includes('cloudinary.com');
    };

    // Función para generar URL de miniatura de Cloudinary
    const getCloudinaryThumbnail = (url, width = 300, height = 200, cropMode = 'fit') => {
        if (!isCloudinaryUrl(url)) return url;

        // Buscar el patrón /upload/ en la URL
        if (url.includes('/upload/')) {
            // Insertar parámetros de transformación después de /upload/
            return url.replace('/upload/', `/upload/c_${cropMode},w_${width},h_${height},q_auto:good/`);
        }
        return url;
    };

    // Función para obtener URL original de Cloudinary (sin transformaciones de miniatura)
    const getCloudinaryOriginal = (url) => {
        if (!isCloudinaryUrl(url)) return url;

        // Remover cualquier transformación entre /upload/ y el nombre del archivo
        // Esto incluye patrones como: c_fill,w_300,h_200,q_auto:good o cualquier otra transformación
        return url.replace(/\/upload\/[^/]+\//, '/upload/');
    };

    // Función para obtener el tipo de contenido basado en la URL
    const getContentType = (url) => {
        if (!url) return 'texto';

        if (isCloudinaryUrl(url)) {
            // Para URLs de Cloudinary, determinar tipo por extensión o metadatos
            if (url.includes('/video/')) return 'video';
            if (url.includes('/image/')) return 'imagen';
            // Fallback: determinar por extensión en la URL
            if (url.match(/\.(mp4|webm|ogg|mov|avi)$/i)) return 'video';
            return 'imagen'; // Por defecto para Cloudinary
        }

        // Lógica existente para Drive y otras URLs
        if (url.includes('drive.google.com')) {
            return 'drive';
        } else if (url.match(/\.(jpeg|jpg|gif|png|webp)$/i)) {
            return 'imagen';
        } else if (url.match(/\.(mp4|webm|ogg)$/i) || url.includes('youtube.com') || url.includes('vimeo.com')) {
            return 'video';
        }

        return 'texto';
    };

    const handleContenidoChange = (e) => {
        let url = e.target.value;
        let tipoContenido = getContentType(url);

        setNuevaPublicacion({
            ...nuevaPublicacion,
            contenidoUrl: url,
            tipoContenido
        });
    };

    // Función auxiliar para formatear fecha al formato argentino
    const formatearFechaArgentina = (fecha) => {
        if (!fecha) return '';
        // Si la fecha está en formato YYYY-MM-DD, crear la fecha sin problemas de zona horaria
        if (fecha.includes('-') && fecha.length === 10) {
            const [anio, mes, dia] = fecha.split('-');
            const date = new Date(anio, mes - 1, dia);
            return date.toLocaleDateString('es-AR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        }
        // Para otros formatos de fecha (como ISO strings)
        const date = new Date(fecha);
        return date.toLocaleDateString('es-AR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const obtenerNombreDia = (fecha) => {
        const dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        // Si la fecha está en formato YYYY-MM-DD, crear la fecha sin problemas de zona horaria
        if (fecha.includes('-') && fecha.length === 10) {
            const [anio, mes, dia] = fecha.split('-');
            const date = new Date(anio, mes - 1, dia);
            return dias[date.getDay()];
        }
        // Para otros formatos de fecha (como ISO strings)
        const date = new Date(fecha);
        return dias[date.getDay()];
    };

    const esHoy = (fecha) => {
        const hoy = new Date();
        let fechaComparar;
        // Si la fecha está en formato YYYY-MM-DD, crear la fecha sin problemas de zona horaria
        if (fecha.includes('-') && fecha.length === 10) {
            const [anio, mes, dia] = fecha.split('-');
            fechaComparar = new Date(anio, mes - 1, dia);
        } else {
            // Para otros formatos de fecha (como ISO strings)
            fechaComparar = new Date(fecha);
        }
        return hoy.toDateString() === fechaComparar.toDateString();
    };

    // Función para convertir fecha del formato argentino a ISO
    const convertirFechaArgentinaAISO = (fechaArgentina) => {
        if (!fechaArgentina) return '';
        const [dia, mes, anio] = fechaArgentina.split('/');
        return `${anio}-${mes}-${dia}`;
    };

    const handleAgregarUrl = () => {
        if (nuevaPublicacion.contenidoUrl) {
            setNuevaPublicacion({
                ...nuevaPublicacion,
                urlsImagenes: [...nuevaPublicacion.urlsImagenes, nuevaPublicacion.contenidoUrl],
                contenidoUrl: '' // Limpiar el input después de agregar
            });
        }
    };


    const handleEliminarUrl = (index) => {
        const nuevasUrls = [...nuevaPublicacion.urlsImagenes];
        nuevasUrls.splice(index, 1);
        setNuevaPublicacion({
            ...nuevaPublicacion,
            urlsImagenes: nuevasUrls
        });
    };

    const handleEliminarUrlEdicion = (index) => {
        const nuevasUrls = [...(editedPublicacion.urlsImagenes || [])];
        nuevasUrls.splice(index, 1);
        setEditedPublicacion({
            ...editedPublicacion,
            urlsImagenes: nuevasUrls
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!nuevaPublicacion.contenido) return;

        if (!nuevaPublicacion.fechaPublicacion) {
            alert('Por favor, selecciona una fecha de publicacion o marca "Indefinido".');
            return;
        }
        if (nuevaPublicacion.fechaPublicacion !== 'indefinido' && !nuevaPublicacion.horaPublicacion) {
            alert('Por favor, selecciona una hora de publicacion.');
            return;
        }
        try {
            const user = auth.currentUser;
            if (!user) {
                alert('Debes iniciar sesión para publicar');
                return;
            }

            // Verificar si el usuario está autorizado
            const publicadorRef = ref(database, `Publicador/${user.uid}`);
            const publicadorSnapshot = await get(publicadorRef);

            if (!publicadorSnapshot.exists()) {
                alert('No tienes permiso para publicar');
                return;
            }

            const publicacionRef = ref(database, 'Publicaciones');
            const nuevaPublicacionRef = push(publicacionRef);

            let programacion = [];
            if (nuevaPublicacion.fechaPublicacion !== 'indefinido' && nuevaPublicacion.fechaPublicacion) {
                const [anio, mes, dia] = nuevaPublicacion.fechaPublicacion.split('-');
                const [horas, minutos] = nuevaPublicacion.horaPublicacion.split(':');
                const fechaLocal = new Date(anio, mes - 1, dia, parseInt(horas, 10), parseInt(minutos, 10), 0, 0);
                programacion = [{
                    fecha: fechaLocal.toISOString(),
                    estado: nuevaPublicacion.estado
                }];
            }
            const publicacionData = {
                contenido: nuevaPublicacion.contenido,
                contenidoUrl: nuevaPublicacion.contenidoUrl || null,
                urlsImagenes: nuevaPublicacion.urlsImagenes || [],
                tipoContenido: nuevaPublicacion.tipoContenido || 'texto',
                tipo: nuevaPublicacion.tipo,
                fechaPublicacion: nuevaPublicacion.fechaPublicacion === 'indefinido' ? '' : nuevaPublicacion.fechaPublicacion,
                horaPublicacion: nuevaPublicacion.fechaPublicacion === 'indefinido' ? '' : nuevaPublicacion.horaPublicacion,
                programacion: programacion,
                fecha: new Date().toISOString(),
                estado: nuevaPublicacion.estado,
                autor: {
                    uid: user.uid,
                    email: user.email
                },
                historial: [{
                    estado: nuevaPublicacion.estado,
                    fecha: new Date().toISOString(),
                    usuario: user.email
                }]
            };

            await set(nuevaPublicacionRef, publicacionData);
            setNuevaPublicacion({
                contenido: '',
                contenidoUrl: '',
                urlsImagenes: [],
                tipoContenido: 'texto',
                tipo: 'todas',
                fechaPublicacion: '',
                horaPublicacion: '',
                estado: 'confirmado'
            });
            setShowModal(false);
        } catch (error) {
            console.error('Error al crear la publicación:', error);
            alert('Error al crear la publicación');
        }
    };

    // Función para marcar una publicación como vista
    const marcarComoVista = async (publicacionId) => {
        if (!auth.currentUser) return;

        try {
            const publicacion = publicaciones.find(p => p.id === publicacionId);
            if (!publicacion) return;

            const vistasRef = ref(database, `VistasPublicaciones/${auth.currentUser.uid}/${publicacionId}`);
            const now = new Date().toISOString();
            await set(vistasRef, {
                ultimaVista: now,
                ultimaActualizacion: publicacion.fecha || now
            });

            // Actualizar el estado local
            setVistasPublicaciones(prev => {
                const nuevasVistas = {
                    ...prev,
                    [publicacionId]: {
                        ultimaVista: now,
                        ultimaActualizacion: publicacion.fecha || now
                    }
                };
                return nuevasVistas;
            });

            // Forzar la actualización del estado de publicaciones no vistas
            actualizarPublicacionesNoVistas(false);
        } catch (error) {
            console.error('Error al marcar como vista:', error);
        }
    };

    const handleVerPublicacion = (publicacion) => {
        setSelectedPublicacion(publicacion);
        setShowModal(true);
        marcarComoVista(publicacion.id);
    };

    const handleEditar = () => {
        setEditMode(true);
        setEditedPublicacion({
            ...selectedPublicacion,
            contenido: selectedPublicacion.contenido || '',
            contenidoUrl: selectedPublicacion.contenidoUrl || '',
            urlsImagenes: selectedPublicacion.urlsImagenes || [],
            tipoContenido: selectedPublicacion.tipoContenido || 'texto',
            fechaPublicacion: selectedPublicacion.fechaPublicacion || '',
            horaPublicacion: selectedPublicacion.horaPublicacion || '',
            tipo: selectedPublicacion.tipo || 'todas'
        });
    };

    const handleGuardarEdicion = async () => {
        // Validación de fecha obligatoria o indefinida en edición
        const indefinidoChecked = indefinidoEditadaRef.current ? indefinidoEditadaRef.current.checked : false;
        const fechaValor = fechaEditadaRef.current ? fechaEditadaRef.current.value : editedPublicacion.fechaPublicacion;
        const horaValor = horaEditadaRef.current ? horaEditadaRef.current.value : editedPublicacion.horaPublicacion;

        if (!indefinidoChecked && !fechaValor) {
            alert('Por favor, selecciona una fecha de publicacion o marca "Indefinido".');
            return;
        }
        if (!indefinidoChecked && !horaValor) {
            alert('Por favor, selecciona una hora de publicacion.');
            return;
        }

        try {
            const publicacionRef = ref(database, `Publicaciones/${selectedPublicacion.id}`);
            // Obtener valores de los refs
            const nuevoContenido = contenidoEditadoRef.current ? contenidoEditadoRef.current.value : editedPublicacion.contenido;
            // Convertir la fecha del formato argentino a ISO
            const fechaISO = indefinidoChecked ? '' : (fechaValor.includes('/') ? convertirFechaArgentinaAISO(fechaValor) : fechaValor);
            
            // NUEVO: Obtener valores de los inputs de URL principal y de imágenes
            const nuevaContenidoUrl = editedPublicacion.contenidoUrl;
            const nuevasUrlsImagenes = editedPublicacion.urlsImagenes || [];

            // Calcular tipoContenido según la nueva URL principal
            let nuevoTipoContenido = 'texto';
            if (nuevaContenidoUrl) {
                if (nuevaContenidoUrl.includes('drive.google.com')) {
                    nuevoTipoContenido = 'drive';
                } else if (nuevaContenidoUrl.match(/\.(jpeg|jpg|gif|png|webp)$/i)) {
                    nuevoTipoContenido = 'imagen';
                } else if (nuevaContenidoUrl.match(/\.(mp4|webm|ogg)$/i) || nuevaContenidoUrl.includes('youtube.com') || nuevaContenidoUrl.includes('vimeo.com')) {
                    nuevoTipoContenido = 'video';
                }
            }

            await update(publicacionRef, {
                contenido: nuevoContenido,
                contenidoUrl: nuevaContenidoUrl,
                urlsImagenes: nuevasUrlsImagenes,
                tipoContenido: nuevoTipoContenido,
                fechaPublicacion: indefinidoChecked ? '' : fechaISO,
                horaPublicacion: horaValor,
                historial: [...(selectedPublicacion.historial || []), {
                    accion: 'editado',
                    fecha: new Date().toISOString(),
                    usuario: {
                        email: auth.currentUser.email,
                        nombre: auth.currentUser.displayName || 'Anónimo'
                    }
                }]
            });
            setEditMode(false);
            window.history.back(); // Cerrar modal via history
            // Enviar correo por edición (pasando texto anterior)
            if (window.confirm("¿Deseas enviar una notificación por email de este cambio?")) {
                await enviarCorreoCambio({ tipo: 'editado', publicacion: { ...selectedPublicacion, ...editedPublicacion, contenido: nuevoContenido, contenidoUrl: nuevaContenidoUrl, urlsImagenes: nuevasUrlsImagenes, tipoContenido: nuevoTipoContenido, fechaPublicacion: indefinidoChecked ? '' : fechaISO, horaPublicacion: horaValor }, anterior: selectedPublicacion });
            }
        } catch (error) {
            console.error('Error al editar la publicación:', error);
            alert('Error al editar la publicación. Por favor, intente nuevamente.');
        }
    };

    const handleConfirmar = async () => {
        try {
            const publicacionRef = ref(database, `Publicaciones/${selectedPublicacion.id}`);
            await update(publicacionRef, {
                estado: 'confirmado',
                historial: [...(selectedPublicacion.historial || []), {
                    accion: 'confirmado',
                    fecha: new Date().toISOString(),
                    usuario: {
                        email: auth.currentUser.email,
                        nombre: auth.currentUser.displayName || 'Anónimo'
                    }
                }]
            });
            setShowModal(false);
            // Enviar correo por confirmación
            if (window.confirm("¿Deseas enviar una notificación por email de este cambio?")) {
                await enviarCorreoCambio({ tipo: 'confirmado', publicacion: selectedPublicacion });
            }
        } catch (error) {
            console.error('Error al confirmar la publicación:', error);
            alert('Error al confirmar la publicación. Por favor, intente nuevamente.');
        }
    };

    const handleRechazar = async () => {
        try {
            const publicacionRef = ref(database, `Publicaciones/${selectedPublicacion.id}`);
            await update(publicacionRef, {
                estado: 'rechazado',
                historial: [...(selectedPublicacion.historial || []), {
                    accion: 'rechazado',
                    fecha: new Date().toISOString(),
                    usuario: {
                        email: auth.currentUser.email,
                        nombre: auth.currentUser.displayName || 'Anónimo'
                    }
                }]
            });
            setShowModal(false);
            // Enviar correo por rechazo
            if (window.confirm("¿Deseas enviar una notificación por email de este cambio?")) {
                await enviarCorreoCambio({ tipo: 'rechazado', publicacion: selectedPublicacion });
            }
        } catch (error) {
            console.error('Error al rechazar la publicación:', error);
            alert('Error al rechazar la publicación. Por favor, intente nuevamente.');
        }
    };

    const handleBorrar = async () => {
        if (!window.confirm('¿Está seguro que desea ocultar esta publicación? Esta acción puede revertirse desde la base de datos.')) {
            return;
        }

        try {
            const publicacionRef = ref(database, `Publicaciones/${selectedPublicacion.id}`);
            await update(publicacionRef, {
                estado: 'borrado',
                historial: [...(selectedPublicacion.historial || []), {
                    accion: 'borrado',
                    fecha: new Date().toISOString(),
                    usuario: {
                        email: auth.currentUser.email,
                        nombre: auth.currentUser.displayName || 'Anónimo'
                    }
                }]
            });
            window.history.back(); // Cerrar modal via history
            setMensajeConfirmacion('La publicación fue ocultada correctamente.');
            setTimeout(() => setMensajeConfirmacion(''), 3500);
            // Enviar correo por borrado
            if (window.confirm("¿Deseas enviar una notificación por email de este cambio?")) {
                await enviarCorreoCambio({ tipo: 'borrado', publicacion: selectedPublicacion });
            }
        } catch (error) {
            console.error('Error al ocultar la publicación:', error);
            alert('Error al ocultar la publicación. Por favor, intente nuevamente.');
        }
    };

    // Nueva función para eliminar completamente la publicación de la base de datos
    const handleEliminarPublicacion = async () => {
        if (!window.confirm('¿Está seguro que desea ELIMINAR PERMANENTEMENTE esta publicación? Esta acción NO se puede deshacer.')) {
            return;
        }
        try {
            const publicacionRef = ref(database, `Publicaciones/${selectedPublicacion.id}`);
            await set(publicacionRef, null); // Elimina el nodo de la publicación
            window.history.back(); // Cierra el modal via history
            setMensajeConfirmacion('La publicación fue eliminada permanentemente.');
            setTimeout(() => setMensajeConfirmacion(''), 3500);
        } catch (error) {
            console.error('Error al eliminar la publicación:', error);
            alert('Error al eliminar la publicación. Por favor, intente nuevamente.');
        }
    };

    const handleAgregarComentario = async (e) => {
        e.preventDefault();
        const comentarioTexto = e.target.comentario.value.trim();
        if (!comentarioTexto) return;

        try {
            const user = auth.currentUser;
            if (!user) {
                alert('Debes iniciar sesión para comentar');
                return;
            }

            const comentariosRef = ref(database, `Publicaciones/${selectedPublicacion.id}/comentarios`);
            const nuevoComentarioRef = push(comentariosRef);

            const comentarioData = {
                texto: comentarioTexto,
                fecha: new Date().toISOString(),
                autor: {
                    email: user.email,
                    uid: user.uid
                }
            };

            await set(nuevoComentarioRef, comentarioData);
            e.target.comentario.value = '';

            // Actualizar el estado local para mostrar el nuevo comentario inmediatamente
            const updatedPublicacion = {
                ...selectedPublicacion,
                comentarios: {
                    ...selectedPublicacion.comentarios,
                    [nuevoComentarioRef.key]: comentarioData
                }
            };
            setSelectedPublicacion(updatedPublicacion);
            // Enviar correo por nuevo comentario
            await enviarCorreoCambio({ tipo: 'comentario', publicacion: selectedPublicacion, comentario: comentarioData });
        } catch (error) {
            console.error('Error al agregar comentario:', error);
            alert('Error al agregar el comentario');
        }
    };

    const handlePendiente = async () => {
        try {
            const publicacionRef = ref(database, `Publicaciones/${selectedPublicacion.id}`);
            await update(publicacionRef, {
                estado: 'pendiente',
                historial: [...(selectedPublicacion.historial || []), {
                    accion: 'marcado como pendiente',
                    fecha: new Date().toISOString(),
                    usuario: {
                        email: auth.currentUser.email,
                        nombre: auth.currentUser.displayName || 'Anónimo'
                    }
                }]
            });
            window.history.back(); // Cierra el modal via history
            // Enviar correo por pendiente
            if (window.confirm("¿Deseas enviar una notificación por email de este cambio?")) {
                await enviarCorreoCambio({ tipo: 'pendiente', publicacion: selectedPublicacion });
            }
        } catch (error) {
            console.error('Error al marcar como pendiente la publicación:', error);
            alert('Error al marcar como pendiente la publicación. Por favor, intente nuevamente.');
        }
    };


    const handleCopyText = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            alert('Texto copiado al portapapeles');
        }).catch(err => {
            console.error('Error al copiar texto:', err);
            alert('Error al copiar el texto');
        });
    };



    // Carrusel manual para vista de lista
    // LazyImage component for lazy loading images with IntersectionObserver
    const LazyImage = ({ src, alt, style, onLoad, onError, className, ...props }) => {
        const imgRef = useRef(null);
        const [isVisible, setIsVisible] = useState(false);
        const [hasLoaded, setHasLoaded] = useState(false);

        useEffect(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect();
                    }
                },
                {
                    rootMargin: '100px', // Start loading 100px before visible
                    threshold: 0.01
                }
            );

            if (imgRef.current) {
                observer.observe(imgRef.current);
            }

            return () => observer.disconnect();
        }, []);

        const handleLoad = (e) => {
            setHasLoaded(true);
            if (onLoad) onLoad(e);
        };

        return (
            <div ref={imgRef} style={{ width: '100%', height: '100%', position: 'relative' }}>
                {/* Placeholder suave que siempre está visible */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#f0f2f5',
                    opacity: hasLoaded ? 0 : 1,
                    transition: 'opacity 0.4s ease',
                    pointerEvents: 'none'
                }}></div>

                {/* Imagen que aparece con fade-in cuando se carga */}
                {isVisible && (
                    <img
                        src={src}
                        alt={alt}
                        style={{
                            ...style,
                            opacity: hasLoaded ? 1 : 0,
                            transition: 'opacity 0.5s ease-in'
                        }}
                        onLoad={handleLoad}
                        onError={onError}
                        className={className}
                        loading="lazy"
                        {...props}
                    />
                )}
            </div>
        );
    };

    // Carrusel manual para vista de lista o modal
    const AutoCarousel = ({ images = [], alt = '', publicacion = null, inModal = false }) => {
        const validImages = (images || []).filter((item) => {
            if (typeof item === 'string') return item.trim() !== '';
            return item && (item.url || item.thumbnail);
        });

        const [index, setIndex] = useState(0);
        const [imageLoading, setImageLoading] = useState(true);

        const currentItem = validImages[index];
        let currentUrl, thumbnailUrl;

        if (typeof currentItem === 'string') {
            currentUrl = currentItem;
            thumbnailUrl = isCloudinaryUrl(currentItem) ? getCloudinaryThumbnail(currentItem) : currentItem;
        } else {
            currentUrl = currentItem?.url || '';
            thumbnailUrl = currentItem?.thumbnail || currentUrl;
        }

        const fileId = getDriveFileId(currentUrl);
        const src = fileId
            ? `https://drive.google.com/uc?export=view&id=${fileId}`
            : thumbnailUrl;


        const downloadLink = fileId
            ? `https://drive.google.com/uc?export=download&id=${fileId}`
            : isCloudinaryUrl(currentUrl) ? getCloudinaryOriginal(currentUrl).replace('/upload/', '/upload/fl_attachment/') : currentUrl;

        const nextSlide = (e) => {
            e.stopPropagation();
            setImageLoading(true);
            setIndex((prev) => (prev + 1) % validImages.length);
        };

        const prevSlide = (e) => {
            e.stopPropagation();
            setImageLoading(true);
            setIndex((prev) => (prev - 1 + validImages.length) % validImages.length);
        };

        return (
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                {/* Loading Spinner */}
                {imageLoading && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 5
                    }}>
                        <div style={{
                            width: '50px',
                            height: '50px',
                            border: '4px solid rgba(255, 255, 255, 0.3)',
                            borderTop: '4px solid white',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }}></div>
                    </div>
                )}

                <img
                    src={src}
                    alt={alt}
                    className="publication-content-image"
                    loading="lazy"
                    referrerPolicy="no-referrer"
                    style={{
                        cursor: 'default',
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        opacity: imageLoading ? 0.3 : 1,
                        transition: 'opacity 0.3s ease'
                    }}
                    onClick={null}
                    onLoad={() => setImageLoading(false)}
                    onError={(e) => {
                        setImageLoading(false);
                        const target = e.target;
                        if (fileId) {
                            target.onerror = null;
                            target.src = getDriveThumbnail(fileId);
                        } else {
                            target.onerror = null;
                            target.parentElement.innerHTML = '<div class="publication-content-placeholder">Error al cargar la imagen</div>';
                        }
                    }}
                />

                {!inModal && validImages.length > 1 && (
                    <>
                        <button
                            onClick={prevSlide}
                            style={{
                                position: 'absolute',
                                left: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'rgba(0, 0, 0, 0.6)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '42px',
                                height: '42px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10,
                                padding: 0,
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}
                            aria-label="Imagen anterior"
                        >
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </button>
                        <button
                            onClick={nextSlide}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'rgba(0, 0, 0, 0.6)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '42px',
                                height: '42px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 10,
                                padding: 0,
                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                            }}
                            aria-label="Siguiente imagen"
                        >
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="9 18 15 12 9 6"></polyline>
                            </svg>
                        </button>
                        <div style={{
                            position: 'absolute',
                            bottom: '10px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            background: 'rgba(0,0,0,0.5)',
                            color: 'white',
                            padding: '2px 8px',
                            borderRadius: '10px',
                            fontSize: '0.75rem',
                            pointerEvents: 'none'
                        }}>
                            {index + 1} / {validImages.length}
                        </div>
                    </>
                )}

                {inModal && (
                    <>
                        {/* Controles de Vista Modal (Zoom / Download) */}
                        <div style={{
                            position: 'absolute',
                            top: '16px',
                            right: '16px',
                            display: 'flex',
                            gap: '8px',
                            zIndex: 20
                        }}>
                            <a
                                href={downloadLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                title="Descargar imagen"
                                style={{
                                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                    color: 'white',
                                    border: 'none',
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'background-color 0.2s',
                                    backdropFilter: 'blur(4px)',
                                    textDecoration: 'none'
                                }}
                                onMouseOver={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'}
                                onMouseOut={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)'}
                            >
                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="7 10 12 15 17 10"></polyline>
                                    <line x1="12" y1="15" x2="12" y2="3"></line>
                                </svg>
                            </a>

                        </div>

                        {validImages.length > 1 && (
                            <>
                                <button
                                    onClick={prevSlide}
                                    style={{
                                        position: 'absolute',
                                        left: '16px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '56px',
                                        height: '56px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 10,
                                        transition: 'background-color 0.2s',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                    }}
                                    aria-label="Imagen anterior"
                                    onMouseOver={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'}
                                    onMouseOut={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)'}
                                >
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="15 18 9 12 15 6"></polyline>
                                    </svg>
                                </button>
                                <button
                                    onClick={nextSlide}
                                    style={{
                                        position: 'absolute',
                                        right: '16px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '56px',
                                        height: '56px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 10,
                                        transition: 'background-color 0.2s',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                    }}
                                    aria-label="Siguiente imagen"
                                    onMouseOver={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'}
                                    onMouseOut={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)'}
                                >
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </button>
                                <div style={{
                                    position: 'absolute',
                                    bottom: '16px',
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    padding: '4px 12px',
                                    borderRadius: '12px',
                                    fontSize: '0.85rem',
                                    pointerEvents: 'none',
                                    backdropFilter: 'blur(4px)'
                                }}>
                                    {index + 1} / {validImages.length}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>
        );
    };

    const renderContenido = (publicacion, inModal = false) => {
        // Determinar el tipo de contenido
        let tipoContenido = getContentType(publicacion.contenidoUrl);

        // Si no hay contenidoUrl pero sí hay URLs de Cloudinary, determinar tipo por la primera URL
        if ((!publicacion.contenidoUrl || tipoContenido === 'texto') &&
            publicacion.urlsImagenes && publicacion.urlsImagenes.length > 0) {
            tipoContenido = getContentType(publicacion.urlsImagenes[0]);
        }

        const renderControls = (currentUrl) => {
            if (!inModal) return null;
            const fileId = getDriveFileId(currentUrl);
            const downloadLink = fileId
                ? `https://drive.google.com/uc?export=download&id=${fileId}`
                : isCloudinaryUrl(currentUrl) ? getCloudinaryOriginal(currentUrl).replace('/upload/', '/upload/fl_attachment/') : currentUrl;

            return (
                <div style={{
                    position: 'absolute',
                    top: '16px',
                    right: '16px',
                    display: 'flex',
                    gap: '8px',
                    zIndex: 20
                }}>
                    <a
                        href={downloadLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                        title="Descargar imagen"
                        style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            color: 'white',
                            border: 'none',
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'background-color 0.2s',
                            backdropFilter: 'blur(4px)',
                            textDecoration: 'none'
                        }}
                        onMouseOver={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)'}
                        onMouseOut={e => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)'}
                    >
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" y1="15" x2="12" y2="3"></line>
                        </svg>
                    </a>

                </div>
            );
        };

        switch (tipoContenido) {
            case 'drive':
                {
                    // Priorizar URLs de Drive si no hay contenidoUrl
                    const primaryUrl = publicacion.contenidoUrl || (publicacion.urlsImagenes && publicacion.urlsImagenes[0]);
                    // Crear array de todas las imágenes con miniaturas para vista previa
                    const allImages = [
                        primaryUrl && {
                            url: primaryUrl,
                            thumbnail: isCloudinaryUrl(primaryUrl) ? getCloudinaryOriginal(primaryUrl) : primaryUrl
                        },
                        ...((publicacion.urlsImagenes || []).filter(url => url !== primaryUrl && Boolean(url))).map(url => ({
                            url,
                            thumbnail: isCloudinaryUrl(url) ? getCloudinaryOriginal(url) : url
                        }))
                    ].filter(Boolean);

                    if (allImages.length > 1) {
                        return (
                            <AutoCarousel images={allImages} alt={publicacion.contenido} publicacion={publicacion} inModal={inModal} />
                        );
                    }
                    const fileId = getDriveFileId(primaryUrl);
                    if (!fileId) return null;
                    return (
                        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                            {inModal ? (
                                <img
                                    src={`https://drive.google.com/uc?export=view&id=${fileId}`}
                                    alt={publicacion.contenido}
                                    className="publication-content-image"
                                    loading="lazy"
                                    referrerPolicy="no-referrer"
                                    style={{
                                        cursor: 'default',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                    onClick={null}
                                    onError={(e) => {
                                        const target = e.target;
                                        target.onerror = null;
                                        target.src = getDriveThumbnail(fileId);
                                    }}
                                />
                            ) : (
                                <LazyImage
                                    src={`https://drive.google.com/uc?export=view&id=${fileId}`}
                                    alt={publicacion.contenido}
                                    className="publication-content-image"
                                    referrerPolicy="no-referrer"
                                    style={{
                                        cursor: 'default',
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }}
                                    onError={(e) => {
                                        const target = e.target;
                                        target.onerror = null;
                                        target.src = getDriveThumbnail(fileId);
                                    }}
                                />
                            )}
                            {/* Overlay indicador de Video/Drive */}
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '48px',
                                    height: '48px',
                                    backgroundColor: 'rgba(0,0,0,0.6)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    pointerEvents: 'none' // Para que el click pase a la imagen/padre
                                }}
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="white" stroke="white" strokeWidth="2">
                                    <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                </svg>
                            </div>
                            {renderControls(primaryUrl)}
                        </div>
                    );
                }
            case 'imagen':
                {
                    // Priorizar URLs de Cloudinary si no hay contenidoUrl
                    const primaryUrl = publicacion.contenidoUrl || (publicacion.urlsImagenes && publicacion.urlsImagenes[0]);
                    const allImages = [
                        primaryUrl && {
                            url: primaryUrl,
                            thumbnail: isCloudinaryUrl(primaryUrl) ? getCloudinaryOriginal(primaryUrl) : primaryUrl
                        },
                        ...((publicacion.urlsImagenes || []).filter(url => url !== primaryUrl && Boolean(url))).map(url => ({
                            url,
                            thumbnail: isCloudinaryUrl(url) ? getCloudinaryOriginal(url) : url
                        }))
                    ].filter(Boolean);

                    if (allImages.length > 1) {
                        return (
                            <AutoCarousel images={allImages} alt={publicacion.contenido} publicacion={publicacion} inModal={inModal} />
                        );
                    }
                    return (
                        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}>
                            {inModal ? (
                                <img
                                    src={isCloudinaryUrl(primaryUrl) ? getCloudinaryOriginal(primaryUrl) : primaryUrl}
                                    alt={publicacion.contenido}
                                    className="publication-content-image"
                                    loading="lazy"
                                    referrerPolicy="no-referrer"
                                    style={{ cursor: 'default', width: '100%', height: '100%', objectFit: 'contain' }}
                                    onClick={null}
                                    onError={(e) => {
                                        e.target.parentElement.innerHTML = '<div class="publication-content-placeholder">Error al cargar la imagen</div>';
                                    }}
                                />
                            ) : (
                                <LazyImage
                                    src={isCloudinaryUrl(primaryUrl) ? getCloudinaryOriginal(primaryUrl) : primaryUrl}
                                    alt={publicacion.contenido}
                                    className="publication-content-image"
                                    referrerPolicy="no-referrer"
                                    style={{ cursor: 'default', width: '100%', height: '100%', objectFit: 'contain' }}
                                    onError={(e) => {
                                        e.target.parentElement.innerHTML = '<div class="publication-content-placeholder">Error al cargar la imagen</div>';
                                    }}
                                />
                            )}
                            {renderControls(primaryUrl)}
                        </div>
                    );
                }
            case 'video':
                if (publicacion.contenidoUrl.includes('youtube.com')) {
                    const videoId = publicacion.contenidoUrl.split('v=')[1];
                    return (
                        <iframe
                            title="Video de YouTube"
                            src={`https://www.youtube.com/embed/${videoId}`}
                            className="publication-content-video"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            loading="lazy"
                        />
                    );
                } else if (publicacion.contenidoUrl.includes('vimeo.com')) {
                    const videoId = publicacion.contenidoUrl.split('vimeo.com/')[1];
                    return (
                        <iframe
                            title="Video de Vimeo"
                            src={`https://player.vimeo.com/video/${videoId}`}
                            className="publication-content-video"
                            allow="autoplay; fullscreen; picture-in-picture"
                            allowFullScreen
                            loading="lazy"
                        />
                    );
                } else {
                    return (
                        <video
                            controls
                            className="publication-content-video"
                        >
                            <source src={publicacion.contenidoUrl} type="video/mp4" />
                            Tu navegador no soporta el elemento de video.
                        </video>
                    );
                }
            default:
                return null;
        }
    };

    // Guardar la posición del scroll antes de actualizar estados que cambian el modal
    const preserveScroll = (fn) => {
        if (modalContentRef.current) {
            scrollPositionRef.current = modalContentRef.current.scrollTop;
        }
        shouldRestoreScroll.current = true;
        fn();
    };

    const Modal = () => {
        const hasMedia = (selectedPublicacion.contenidoUrl && (selectedPublicacion.tipoContenido === 'video' || selectedPublicacion.tipoContenido === 'imagen' || selectedPublicacion.tipoContenido === 'drive')) ||
            (selectedPublicacion.urlsImagenes && selectedPublicacion.urlsImagenes.length > 0);

        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
                backdropFilter: 'blur(5px)'
            }}>
                <div
                    className="publication-detail-modal"
                    style={{
                        backgroundColor: 'white',
                        borderRadius: editMode ? '12px' : '0',
                        width: editMode ? '90%' : '100vw',
                        maxWidth: editMode ? '800px' : 'none',
                        height: editMode ? 'auto' : '95vh', // Slightly reduced height from 100vh
                        maxHeight: editMode ? '90vh' : 'none',
                        marginTop: editMode ? '0' : '2vh', // Add some top margin to bring it down
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                        overflow: 'hidden'
                    }}
                >
                    {/* Header Simplificado */}
                    <div style={{
                        padding: '16px 24px',
                        borderBottom: '1px solid #e2e8f0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: 'white',
                        zIndex: 10,
                        flexShrink: 0
                    }}>
                        <h3 style={{ margin: 0, color: '#1a3b5d', fontSize: '1.25rem', fontWeight: 600 }}>
                            {editMode ? 'Editar Publicación' : 'Detalles de la Publicación'}
                        </h3>
                        <button
                            onClick={() => {
                                setShowModal(false);
                                setEditMode(false);
                            }}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                fontSize: '1.5rem',
                                color: '#718096',
                                cursor: 'pointer',
                                padding: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                transition: 'background 0.2s'
                            }}
                            onMouseOver={e => e.currentTarget.style.backgroundColor = '#f7fafc'}
                            onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>

                    {editMode ? (
                        /* EDIT MODE LAYOUT (Original) */
                        <div style={{ overflowY: 'auto', flex: 1, padding: '24px' }} ref={modalContentRef}>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', color: '#2d3748', fontWeight: 500 }}>
                                    Texto de la publicación
                                </label>
                                <textarea
                                    name="contenidoEditado"
                                    defaultValue={editedPublicacion.contenido}
                                    ref={contenidoEditadoRef}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        borderRadius: '8px',
                                        border: '1px solid #e2e8f0',
                                        minHeight: '120px',
                                        fontSize: '0.95rem',
                                        fontFamily: 'inherit',
                                        resize: 'vertical'
                                    }}
                                />
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', color: '#2d3748', fontWeight: 500 }}>
                                    URL principal (imagen/video/drive)
                                </label>
                                <input
                                    type="url"
                                    name="contenidoUrlEditada"
                                    placeholder="https://..."
                                    value={editedPublicacion.contenidoUrl}
                                    onChange={e => {
                                        let tipoContenido = 'texto';
                                        const url = e.target.value;
                                        if (url) {
                                            if (url.includes('drive.google.com')) {
                                                tipoContenido = 'drive';
                                            } else if (url.match(/\.(jpeg|jpg|gif|png|webp)$/i)) {
                                                tipoContenido = 'imagen';
                                            } else if (url.match(/\.(mp4|webm|ogg)$/i) || url.includes('youtube.com') || url.includes('vimeo.com')) {
                                                tipoContenido = 'video';
                                            }
                                        }
                                        setEditedPublicacion({
                                            ...editedPublicacion,
                                            contenidoUrl: url,
                                            tipoContenido
                                        });
                                    }}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '8px',
                                        border: '1px solid #e2e8f0',
                                        fontSize: '0.95rem'
                                    }}
                                />
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', color: '#2d3748', fontWeight: 500 }}>
                                    Subir archivos (Cloudinary)
                                </label>
                                <div
                                    style={{
                                        border: '2px dashed #cbd5e0',
                                        borderRadius: '8px',
                                        padding: '20px',
                                        textAlign: 'center',
                                        backgroundColor: isDragOver ? '#ebf8ff' : '#f7fafc',
                                        transition: 'all 0.2s',
                                        cursor: 'pointer'
                                    }}
                                    onDragOver={(e) => { e.preventDefault(); setIsDragOver(true); }}
                                    onDragLeave={() => setIsDragOver(false)}
                                    onDrop={(e) => {
                                        e.preventDefault();
                                        setIsDragOver(false);
                                        handleEditFiles(e.dataTransfer.files);
                                    }}
                                    onClick={() => document.getElementById('edit-file-input').click()}
                                >
                                    <input
                                        type="file"
                                        id="edit-file-input"
                                        multiple
                                        accept="image/*,video/*"
                                        style={{ display: 'none' }}
                                        onChange={(e) => handleEditFiles(e.target.files)}
                                    />
                                    <div style={{ pointerEvents: 'none' }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#a0aec0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '8px' }}>
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                            <polyline points="17 8 12 3 7 8"></polyline>
                                            <line x1="12" y1="3" x2="12" y2="15"></line>
                                        </svg>
                                        <p style={{ margin: 0, color: '#718096', fontSize: '0.9rem' }}>
                                            Haz click o arrastra imagenes/videos aquí
                                        </p>
                                    </div>
                                    {uploadingFiles.length > 0 && (
                                        <div style={{ marginTop: '12px', textAlign: 'left' }}>
                                            {uploadingFiles.map((fileObj, idx) => (
                                                <div key={idx} style={{
                                                    fontSize: '0.85rem',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    marginBottom: '4px',
                                                    color: fileObj.status === 'error' ? '#e53e3e' : '#48bb78'
                                                }}>
                                                    <span>{fileObj.status === 'completed' ? '✓' : fileObj.status === 'error' ? '✕' : '⟳'}</span>
                                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '200px' }}>{fileObj.file.name}</span>
                                                    <span style={{ marginLeft: 'auto', fontSize: '0.75rem', opacity: 0.8 }}>
                                                        {fileObj.status === 'uploading' ? 'Subiendo...' : fileObj.status === 'completed' ? 'Listo' : 'Error'}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', color: '#2d3748', fontWeight: 500 }}>
                                    Agregar URL de imagen adicional
                                </label>
                                <div style={{ display: 'flex', flexDirection: window.innerWidth <= 600 ? 'column' : 'row', gap: '10px' }}>
                                    <input
                                        type="url"
                                        name="urlImagenAdicional"
                                        placeholder="https://..."
                                        ref={urlEditadaRef}
                                        style={{
                                            flex: 1,
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #e2e8f0',
                                            fontSize: '0.95rem'
                                        }}
                                    />
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const url = urlEditadaRef.current ? urlEditadaRef.current.value : '';
                                            if (!url) return;
                                            setEditedPublicacion({
                                                ...editedPublicacion,
                                                urlsImagenes: [...(editedPublicacion.urlsImagenes || []), url]
                                            });
                                            if (urlEditadaRef.current) urlEditadaRef.current.value = '';
                                        }}
                                        style={{
                                            padding: '10px 20px',
                                            backgroundColor: '#3182ce',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            cursor: 'pointer',
                                            fontWeight: 500
                                        }}
                                    >
                                        Agregar
                                    </button>
                                </div>
                                {editedPublicacion.urlsImagenes && editedPublicacion.urlsImagenes.length > 0 && (
                                    <div style={{ marginTop: '15px' }}>
                                        <h4 style={{ margin: '0 0 10px 0', color: '#4a5568', fontSize: '0.9rem' }}>URLs agregadas:</h4>
                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                                            gap: '12px'
                                        }}>
                                            {editedPublicacion.urlsImagenes.map((url, index) => {
                                                const fileId = getDriveFileId(url);
                                                return (
                                                    <div key={index} style={{
                                                        position: 'relative',
                                                        paddingTop: '75%',
                                                        backgroundColor: '#f7fafc',
                                                        borderRadius: '8px',
                                                        overflow: 'hidden',
                                                        border: '1px solid #e2e8f0'
                                                    }}>
                                                        <img
                                                            src={fileId ? getDriveThumbnail(fileId) : url}
                                                            alt={`Preview ${index + 1}`}
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover'
                                                            }}
                                                            onError={(e) => {
                                                                e.target.style.display = 'none';
                                                            }}
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => handleEliminarUrlEdicion(index)}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '4px',
                                                                right: '4px',
                                                                padding: '4px 8px',
                                                                backgroundColor: 'rgba(229, 62, 62, 0.9)',
                                                                color: 'white',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                cursor: 'pointer',
                                                                fontSize: '0.75rem'
                                                            }}
                                                        >
                                                            Eliminar
                                                        </button>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: '20px',
                                marginBottom: '24px'
                            }}>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '8px', color: '#2d3748', fontWeight: 500 }}>
                                        Fecha de publicación
                                    </label>
                                    <input
                                        type="date"
                                        name="fechaEditada"
                                        defaultValue={editedPublicacion.fechaPublicacion}
                                        ref={fechaEditadaRef}
                                        onClick={(e) => {
                                            try {
                                                if (e.currentTarget.showPicker) e.currentTarget.showPicker();
                                            } catch (err) {
                                                console.log("Picker blocked or not supported", err);
                                            }
                                        }}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #e2e8f0',
                                            cursor: 'pointer'
                                        }}
                                        disabled={editedPublicacion.fechaPublicacion === 'indefinido'}
                                    />
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem', color: '#4a5568', marginTop: '8px', cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            name="indefinidoEditada"
                                            ref={indefinidoEditadaRef}
                                            defaultChecked={editedPublicacion.fechaPublicacion === 'indefinido'}
                                        />
                                        Definir como fecha indefinida
                                    </label>
                                </div>
                                <div>
                                    <label style={{ display: 'block', marginBottom: '8px', color: '#2d3748', fontWeight: 500 }}>
                                        Hora
                                    </label>
                                    <input
                                        type="time"
                                        name="horaEditada"
                                        defaultValue={editedPublicacion.horaPublicacion}
                                        ref={horaEditadaRef}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: '1px solid #e2e8f0'
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '12px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e2e8f0'
                            }}>
                                <button
                                    onClick={() => {
                                        setEditMode(false);
                                        // Reset refs logic
                                        if (contenidoEditadoRef.current) contenidoEditadoRef.current.value = '';
                                        if (fechaEditadaRef.current) fechaEditadaRef.current.value = '';
                                        if (horaEditadaRef.current) horaEditadaRef.current.value = '';
                                        if (indefinidoEditadaRef.current) indefinidoEditadaRef.current.checked = false;
                                    }}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#edf2f7',
                                        color: '#4a5568',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontWeight: 500
                                    }}
                                >
                                    Cancelar
                                </button>
                                <button
                                    onClick={handleGuardarEdicion}
                                    style={{
                                        padding: '10px 20px',
                                        backgroundColor: '#3182ce',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontWeight: 500
                                    }}
                                >
                                    Guardar Cambios
                                </button>
                            </div>
                        </div>
                    ) : (
                        /* VIEW MODE LAYOUT (Split Screen) */
                        <div style={{
                            display: 'flex',
                            flexDirection: window.innerWidth <= 800 ? 'column' : 'row',
                            flex: 1,
                            overflow: window.innerWidth <= 800 ? 'auto' : 'hidden'
                        }}>
                            {/* LEFT PANEL: Media/Carousel */}
                            <div style={{
                                flex: hasMedia ? (window.innerWidth <= 800 ? '0 0 auto' : '1.5') : '0', // Mobile: Auto height. Desktop: Flex
                                backgroundColor: '#000',
                                position: 'relative',
                                display: hasMedia ? 'block' : 'none',
                                overflow: 'hidden',
                                borderRight: window.innerWidth > 800 ? '1px solid #e2e8f0' : 'none',
                                borderBottom: window.innerWidth <= 800 ? '1px solid #e2e8f0' : 'none',
                                height: window.innerWidth <= 800 ? '80vh' : 'auto' // Mobile: Tall Fixed Height
                            }}>
                                {hasMedia ? renderContenido(selectedPublicacion, true) : null}
                            </div>

                            {/* RIGHT PANEL: Details & Actions */}
                            <div style={{
                                flex: '1',
                                display: 'flex',
                                flexDirection: 'column',
                                backgroundColor: 'white',
                                overflow: window.innerWidth <= 800 ? 'visible' : 'hidden'
                            }}>
                                {/* Scrollable Content */}
                                <div style={{
                                    overflowY: window.innerWidth <= 800 ? 'visible' : 'auto',
                                    flex: 1,
                                    padding: '24px',
                                    paddingBottom: window.innerWidth <= 800 ? '120px' : '24px' // Espacio extra para el footer fijo en móvil
                                }} ref={modalContentRef}>
                                    {/* META INFO ROW */}
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        gap: '12px',
                                        marginBottom: '20px',
                                        fontSize: '0.9rem',
                                        color: '#718096'
                                    }} className="modal-meta-row">
                                        <span style={{
                                            backgroundColor: '#ebf8ff',
                                            color: '#3182ce',
                                            padding: '4px 10px',
                                            borderRadius: '20px',
                                            fontWeight: 600,
                                            fontSize: '0.8rem',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.05em'
                                        }}>
                                            {tipoLabel(selectedPublicacion.tipo)}
                                        </span>

                                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                                            {(!selectedPublicacion.fechaPublicacion || selectedPublicacion.fechaPublicacion === 'indefinido')
                                                ? 'Fecha indefinida'
                                                : `${formatearFechaArgentina(selectedPublicacion.fechaPublicacion)} ${selectedPublicacion.horaPublicacion ? ' • ' + selectedPublicacion.horaPublicacion : ''}`}
                                        </span>

                                        <span style={{ color: '#e2e8f0' }}>|</span>

                                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }} title="Autor">
                                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                            {selectedPublicacion.autor?.email?.split('@')[0]}
                                        </span>

                                        <span style={{ marginLeft: 'auto', fontSize: '0.8rem', fontFamily: 'monospace', color: '#a0aec0' }}>
                                            ID: {selectedPublicacion.id?.slice(-6)}
                                        </span>
                                    </div>

                                    {/* CONTENT TEXT */}
                                    <div style={{
                                        fontSize: '1rem',
                                        lineHeight: '1.7',
                                        color: '#2d3748',
                                        whiteSpace: 'pre-wrap',
                                        marginBottom: '24px'
                                    }} className="modal-text-content">
                                        {formatearTextoConEnlaces(selectedPublicacion.contenido)}
                                    </div>

                                    {/* QUICK ACTIONS (Copy) */}
                                    <div style={{ display: 'flex', gap: '8px', marginBottom: '32px' }}>
                                        <button
                                            onClick={() => handleCopyText(selectedPublicacion.contenido)}
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '6px 14px',
                                                backgroundColor: 'white',
                                                border: '1px solid #e2e8f0',
                                                borderRadius: '20px',
                                                color: '#718096',
                                                fontSize: '0.85rem',
                                                fontWeight: 500,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s'
                                            }}
                                            className="modal-copy-btn"
                                            onMouseOver={e => { e.currentTarget.style.borderColor = '#cbd5e0'; e.currentTarget.style.color = '#4a5568'; }}
                                            onMouseOut={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#718096'; }}
                                        >
                                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" /></svg>
                                            Copiar texto
                                        </button>
                                        <button
                                            onClick={async () => {
                                                preserveScroll(async () => {
                                                    const url = `${window.location.origin}${window.location.pathname.replace(/\/pendientes(\/.*)?$/, '')}/pendientes/${selectedPublicacion.id}`;
                                                    await navigator.clipboard.writeText(url);
                                                    setCopied(true);
                                                    setTimeout(() => setCopied(false), 2000);
                                                });
                                            }}
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '6px 14px',
                                                backgroundColor: 'white',
                                                border: '1px solid #e2e8f0',
                                                borderRadius: '20px',
                                                color: '#718096',
                                                fontSize: '0.85rem',
                                                fontWeight: 500,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s'
                                            }}
                                            className="modal-copy-btn"
                                            onMouseOver={e => { e.currentTarget.style.borderColor = '#cbd5e0'; e.currentTarget.style.color = '#4a5568'; }}
                                            onMouseOut={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.color = '#718096'; }}
                                        >
                                            {copied ? (
                                                <><svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7" /></svg> Copiado</>
                                            ) : (
                                                <><svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M10 13a5 5 0 0 1 7 7l-3 3a5 5 0 0 1-7-7" /><path d="M14 11a5 5 0 0 0-7-7l-3 3a5 5 0 0 0 7 7" /></svg> Copiar enlace</>
                                            )}
                                        </button>
                                    </div>

                                    {/* COMMENTS SECTION */}
                                    <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '24px', marginBottom: '20px' }} className="comments-section">
                                        <h4 style={{ margin: '0 0 16px 0', color: '#1a3b5d', fontSize: '1.1rem' }}>Comentarios</h4>

                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '20px' }}>
                                            {selectedPublicacion.comentarios && Object.entries(selectedPublicacion.comentarios)
                                                .sort((a, b) => new Date(a[1].fecha) - new Date(b[1].fecha))
                                                .map(([id, comentario]) => (
                                                    <div key={id} style={{ display: 'flex', gap: '10px' }} className="comment-item">
                                                        <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: '#cbd5e0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: 'white', flexShrink: 0 }}>
                                                            {comentario.autor.email[0].toUpperCase()}
                                                        </div>
                                                        <div style={{ backgroundColor: '#f7fafc', padding: '10px 14px', borderRadius: '0 12px 12px 12px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }} className="comment-header">
                                                                <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#2d3748' }}>{comentario.autor.email}</span>
                                                                <span style={{ fontSize: '0.75rem', color: '#a0aec0' }}>{new Date(comentario.fecha).toLocaleString()}</span>
                                                            </div>
                                                            <p style={{ margin: 0, fontSize: '0.95rem', color: '#4a5568', lineHeight: 1.4 }}>
                                                                {formatearTextoConEnlaces(comentario.texto)}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>

                                        <form onSubmit={(e) => { preserveScroll(() => handleAgregarComentario(e)); }} style={{ display: 'flex', gap: '12px' }} className="comment-form">
                                            <input
                                                name="comentario"
                                                placeholder="Escribe un comentario..."
                                                style={{
                                                    flex: 1,
                                                    padding: '10px 14px',
                                                    borderRadius: '20px',
                                                    border: '1px solid #e2e8f0',
                                                    backgroundColor: '#f8f9fa',
                                                    fontSize: '0.95rem'
                                                }}
                                                autoComplete="off"
                                                className="comment-input"
                                            />
                                            <button type="submit" className="comment-submit-btn" style={{ padding: '8px 20px', backgroundColor: '#1a3b5d', color: 'white', border: 'none', borderRadius: '20px', cursor: 'pointer', fontWeight: 500 }}>
                                                Enviar
                                            </button>
                                        </form>
                                    </div>

                                    {/* HISTORY & VIEWS DROPDOWNS (Compact) */}
                                    {(isAdmin || isPublicador) && (
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
                                            <button onClick={() => preserveScroll(() => setVistosPorExpandido(!vistosPorExpandido))} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', fontSize: '0.9rem', color: '#4a5568' }}>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                                    Vistos por ({obtenerVistasPublicacion(selectedPublicacion.id).length})
                                                </span>
                                                <span>{vistosPorExpandido ? '▲' : '▼'}</span>
                                            </button>
                                            {vistosPorExpandido && (
                                                <div style={{ maxHeight: '150px', overflowY: 'auto', padding: '10px', backgroundColor: '#f7fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                                    {obtenerVistasPublicacion(selectedPublicacion.id).map((vista, idx) => (
                                                        <div key={idx} style={{ fontSize: '0.85rem', padding: '4px 0', borderBottom: '1px dashed #e2e8f0', display: 'flex', justifyContent: 'space-between' }} className="views-item">
                                                            <span>{obtenerEmailUsuario(vista.userId)}</span>
                                                            <span style={{ color: '#a0aec0' }}>{new Date(vista.ultimaVista).toLocaleDateString()} {new Date(vista.ultimaVista).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {selectedPublicacion.historial && selectedPublicacion.historial.length > 0 && (
                                                <>
                                                    <button onClick={() => preserveScroll(() => setHistorialExpandido(!historialExpandido))} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 16px', backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', cursor: 'pointer', fontSize: '0.9rem', color: '#4a5568' }}>
                                                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                                            Historial de cambios
                                                        </span>
                                                        <span>{historialExpandido ? '▲' : '▼'}</span>
                                                    </button>
                                                    {historialExpandido && (
                                                        <div style={{ maxHeight: '150px', overflowY: 'auto', padding: '10px', backgroundColor: '#f7fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                                                            {selectedPublicacion.historial.map((accion, idx) => (
                                                                <div key={idx} style={{ fontSize: '0.85rem', padding: '6px 0', borderBottom: '1px dashed #e2e8f0' }} className="history-item">
                                                                    <div style={{ fontWeight: 500 }}>{accion.usuario.email}</div>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#718096' }} className="history-bottom-row">
                                                                        <span>{accion.accion}</span>
                                                                        <span>{new Date(accion.fecha).toLocaleDateString()} {new Date(accion.fecha).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Footer (Actions) */}
                                {(isAdmin || isPublicador) && (
                                    <div style={{
                                        padding: window.innerWidth <= 800 ? '12px 16px' : '16px 24px',
                                        borderTop: '1px solid #e2e8f0',
                                        backgroundColor: 'white',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: window.innerWidth <= 800 ? 'center' : 'flex-end',
                                        gap: window.innerWidth <= 800 ? '8px' : '12px',
                                        zIndex: 30, // Mayor zIndex para estar sobre todo
                                        // Estilos para móvil fijado abajo
                                        ...(window.innerWidth <= 800 ? {
                                            position: 'fixed',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            boxShadow: '0 -4px 10px rgba(0, 0, 0, 0.1)',
                                            maxHeight: '30vh',
                                            overflowY: 'auto' // Por si acaso hay muchos botones en pantallas muy pequeñas
                                        } : {})
                                    }} className="publication-actions-container">
                                        {isPublicador && (
                                            <>
                                                <button onClick={handlePendiente} className="publication-action-btn" style={{ padding: '8px 16px', backgroundColor: '#edf2f7', color: '#4a5568', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500 }}>
                                                    Pendiente
                                                </button>
                                                <button onClick={handleDuplicar} className="publication-action-btn" style={{ padding: '8px 16px', backgroundColor: '#edf2f7', color: '#d69e2e', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500 }}>
                                                    Duplicar
                                                </button>
                                                <div style={{ width: '1px', backgroundColor: '#e2e8f0', margin: '0 4px' }} className="publication-separator"></div>
                                                <button onClick={handleEditar} className="publication-action-btn" style={{ padding: '8px 16px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500 }}>
                                                    Editar
                                                </button>
                                                <button onClick={handleBorrar} className="publication-action-btn" style={{ padding: '8px 16px', backgroundColor: '#fff5f5', color: '#e53e3e', border: '1px solid #feb2b2', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500 }}>
                                                    Ocultar
                                                </button>
                                                <button onClick={handleEliminarPublicacion} className="publication-action-btn" style={{ padding: '8px 16px', backgroundColor: '#1a202c', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500 }}>
                                                    Eliminar
                                                </button>
                                            </>
                                        )}

                                        {(isAdmin || isPublicador) && (
                                            <div style={{ display: 'flex', gap: '8px', marginLeft: isPublicador ? '12px' : 0 }} className="publication-actions-group">
                                                <button onClick={handleConfirmar} className="publication-action-btn" style={{ padding: '8px 20px', backgroundColor: '#48bb78', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.95rem', fontWeight: 600, boxShadow: '0 2px 4px rgba(72,187,120,0.2)' }}>
                                                    Confirmar
                                                </button>
                                                <button onClick={handleRechazar} className="publication-action-btn" style={{ padding: '8px 20px', backgroundColor: '#f56565', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '0.95rem', fontWeight: 600, boxShadow: '0 2px 4px rgba(245,101,101,0.2)' }}>
                                                    Rechazar
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };


    // Restaurar la posición del scroll solo si se usó preserveScroll
    useEffect(() => {
        if (shouldRestoreScroll.current && modalContentRef.current) {
            modalContentRef.current.scrollTop = scrollPositionRef.current;
            shouldRestoreScroll.current = false;
        }
    });



    // Agregar estilos globales para el selector responsive solo una vez
    if (!document.getElementById('tipo-contenido-selector-responsive-style')) {
        const responsiveStyle = document.createElement('style');
        responsiveStyle.id = 'tipo-contenido-selector-responsive-style';
        responsiveStyle.innerText = `
            @media (max-width: 600px) {
                .tipo-contenido-selector-responsive {
                    flex-direction: column !important;
                    flex-wrap: nowrap !important;
                    overflow-x: unset !important;
                    gap: 10px !important;
                    justify-content: flex-start !important;
                    align-items: stretch !important;
                    padding-bottom: 0 !important;
                }
                .tipo-contenido-selector-responsive button {
                    min-width: 0 !important;
                    width: 100% !important;
                    font-size: 0.98rem !important;
                    white-space: normal !important;
                }
            }
        `;
        document.head.appendChild(responsiveStyle);
    }

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '200px'
            }}>
                <div className="spinner"></div>
            </div>
        );
    }

    const handleDuplicar = () => {
        if (!selectedPublicacion) return;
        // Copiar los datos de la publicación seleccionada, omitiendo campos que no deben copiarse
        setNuevaPublicacion({
            contenido: selectedPublicacion.contenido || '',
            contenidoUrl: selectedPublicacion.contenidoUrl || '',
            urlsImagenes: selectedPublicacion.urlsImagenes ? [...selectedPublicacion.urlsImagenes] : [],
            tipoContenido: selectedPublicacion.tipoContenido || 'texto',
            tipo: selectedPublicacion.tipo || 'todas',
            fechaPublicacion: '', // Limpiar para que el usuario elija la nueva fecha
            horaPublicacion: '', // Limpiar para que el usuario elija la nueva hora
            estado: 'confirmado'
        });
        setShowForm(true);
        setShowModal(false);
    };

    // Utilidad para formatear texto: saltos de línea y enlaces
    function formatearTextoConEnlaces(texto) {
        if (!texto) return null;
        // Regex para detectar URLs
        const urlRegex = /(https?:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=%]+)|(www\.[\w\-._~:/?#[\]@!$&'()*+,;=%]+)/gi;
        // Split por saltos de línea
        const partes = texto.split(/(\n|\r\n|\r)/g);
        return partes.map((parte, i) => {
            if (parte.match(/^(\n|\r\n|\r)$/)) {
                return <br key={i} />;
            }
            // Detectar y convertir URLs en enlaces
            const subpartes = parte.split(urlRegex);
            return subpartes.map((sub, j) => {
                if (!sub) return null;
                if (sub.match(urlRegex)) {
                    let href = sub;
                    if (!href.startsWith('http')) href = 'https://' + href;
                    return <a key={j} href={href} target="_blank" rel="noopener noreferrer" style={{ color: '#1a3b5d', textDecoration: 'underline' }}>{sub}</a>;
                }
                return <React.Fragment key={j}>{sub}</React.Fragment>;
            });
        });
    }

    // Función para truncar texto para vista previa
    function truncarTexto(texto, maxLength = 100) {
        if (!texto) return '';
        if (texto.length <= maxLength) return texto;
        return texto.substring(0, maxLength).trim() + '...';
    }

    // Función para verificar si una publicación tiene cambios no vistos
    const tieneCambiosNoVistos = (publicacion) => {
        // Si no hay usuario autenticado o no hay datos de vistas, no mostrar indicador
        if (!auth.currentUser || !vistasPublicaciones || Object.keys(vistasPublicaciones).length === 0) {
            return false;
        }

        // No mostrar badge "Nuevo" en publicaciones con fecha pasada
        if (publicacion.fechaPublicacion && publicacion.fechaPublicacion !== 'indefinido' && publicacion.fechaPublicacion !== '') {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const fechaPub = new Date(publicacion.fechaPublicacion + 'T00:00:00');
            if (fechaPub < today) return false;
        }

        const vista = vistasPublicaciones[publicacion.id];

        // Si nunca se vio esta publicación, considerarla como nueva
        if (!vista || !vista.ultimaVista) {
            return true;
        }

        const ultimaVista = new Date(vista.ultimaVista);
        const ultimaActualizacion = vista.ultimaActualizacion ? new Date(vista.ultimaActualizacion) : new Date(publicacion.fecha);

        // Verificar si hay nuevos comentarios
        const comentarios = publicacion.comentarios || {};
        const hayNuevosComentarios = Object.values(comentarios).some(
            comentario => new Date(comentario.fecha) > ultimaVista
        );

        // Verificar si hubo cambios en la publicación
        const huboCambios = ultimaActualizacion > ultimaVista;

        return hayNuevosComentarios || huboCambios;
    };

    // Agregar funciones auxiliares arriba del return principal:
    function tipoLabel(tipo) {
        switch (tipo) {
            case 'todas': return 'Todas';
            case 'facebook': return 'Facebook';
            case 'instagram': return 'Instagram';
            case 'tiktok': return 'TikTok';
            default: return tipo;
        }
    }
    function tipoColorFondo(tipo) {
        switch (tipo) {
            case 'todas': return '#dcfce7';
            case 'facebook': return '#dbeafe';
            case 'instagram': return '#fce7f3';
            case 'tiktok': return '#e5e7eb';
            default: return '#e2e8f0';
        }
    }
    function tipoColorTexto(tipo) {
        switch (tipo) {
            case 'todas': return '#166534';
            case 'facebook': return '#1d4ed8';
            case 'instagram': return '#be185d';
            case 'tiktok': return '#111827';
            default: return '#1a3b5d';
        }
    }
    function tipoColorBorde(tipo) {
        switch (tipo) {
            case 'todas': return '#86efac';
            case 'facebook': return '#93c5fd';
            case 'instagram': return '#f9a8d4';
            case 'tiktok': return '#9ca3af';
            default: return '#cbd5e1';
        }
    }    function estadoLabel(estado) {
        switch (estado) {
            case 'confirmado': return 'Confirmado';
            case 'rechazado': return 'Rechazado';
            case 'ausente': return 'Ausente';
            case 'borrado': return 'Borrado';
            case 'pendiente': return 'Pendiente';
            case 'nuevo': return 'Nuevo';
            default: return estado;
        }
    }
    function estadoColorFondo(estado) {
        switch (estado) {
            case 'confirmado': return '#c6f6d5';
            case 'rechazado': return '#fed7d7';
            case 'ausente': return '#fefcbf';
            case 'borrado': return '#e2e8f0';
            case 'pendiente': return '#bee3f8';
            case 'nuevo': return '#fed7d7';
            default: return '#e2e8f0';
        }
    }
    function estadoColorTexto(estado) {
        switch (estado) {
            case 'confirmado': return '#276749';
            case 'rechazado': return '#c53030';
            case 'ausente': return '#b7791f';
            case 'borrado': return '#718096';
            case 'pendiente': return '#2b6cb0';
            case 'nuevo': return '#c53030';
            default: return '#1a3b5d';
        }
    }
    function estadoColorBorde(estado) {
        switch (estado) {
            case 'confirmado': return '#68d391';
            case 'rechazado': return '#feb2b2';
            case 'ausente': return '#faf089';
            case 'borrado': return '#cbd5e1';
            case 'pendiente': return '#90cdf4';
            case 'nuevo': return '#feb2b2';
            default: return '#cbd5e1';
        }
    }


    const renderPreviewModal = () => {
        if (!previewFile) return null;
        const { url, tipoContenido } = previewFile;
        let content = null;
        if (tipoContenido === 'drive') {
            const fileId = getDriveFileId(url);
            if (!fileId) return null;
            content = (
                <img
                    src={`https://drive.google.com/uc?export=view&id=${fileId}`}
                    alt="Vista previa"
                    style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px', background: '#000' }}
                    referrerPolicy="no-referrer"
                    onError={(e) => {
                        const target = e.target;
                        target.onerror = null;
                        target.src = getDriveThumbnail(fileId);
                    }}
                />
            );
        } else if (tipoContenido === 'imagen') {
            content = (
                <img
                    src={url}
                    alt="Vista previa"
                    style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px', background: '#000' }}
                />
            );
        } else if (tipoContenido === 'video') {
            if (url && url.includes('drive.google.com')) {
                const fileIdVideo = getDriveFileId(url);
                content = (
                    <img
                        src={fileIdVideo ? `https://drive.google.com/thumbnail?id=${fileIdVideo}&sz=w800` : url}
                        alt="Vista previa"
                        style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px', background: '#000' }}
                        referrerPolicy="no-referrer"
                    />
                );
            } else {
                content = (
                    <video controls style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px', background: '#000' }}>
                        <source src={url} />
                        Tu navegador no soporta el video.
                    </video>
                );
            }
        }
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.92)',
                zIndex: 5000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
            }}
                onClick={() => setPreviewFile(null)}
            >
                <button
                    onClick={e => { e.stopPropagation(); setPreviewFile(null); }}
                    style={{
                        position: 'absolute',
                        top: 30,
                        right: 40,
                        fontSize: '2.5rem',
                        background: 'none',
                        border: 'none',
                        color: '#fff',
                        cursor: 'pointer',
                        zIndex: 5100
                    }}
                    aria-label="Cerrar vista previa"
                >×</button>
                {content}
            </div>
        );
    };

    return (
        <div className="publications-container" style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '20px',
            paddingBottom: window.innerWidth <= 768 ? '400px' : '100px'
        }}>
            <div className="header-container">
                <div className="header-left">
                    <h2 className="header-title">
                        Publicaciones
                    </h2>

                    <select
                        value={tipoSeleccionado}
                        onChange={(e) => {
                            setTipoSeleccionado(e.target.value);
                            setVisibleDatesCount(5); // Reset pagination when filter changes
                        }}
                        className="header-select"
                    >
                        <option value="todas">Todas</option>
                        <option value="facebook">Facebook</option>
                        <option value="instagram">Instagram</option>
                        <option value="tiktok">TikTok</option>
                    </select>

                    <div className="header-date-group">
                        <div style={{ position: 'relative', flex: 1 }}>
                            {!fechaFiltro && (
                                <span style={{
                                    position: 'absolute',
                                    left: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: '#718096',
                                    pointerEvents: 'none',
                                    fontSize: window.innerWidth <= 768 ? '1rem' : '0.9rem',
                                    fontWeight: 500,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                    </svg>
                                    Filtrar por fecha
                                </span>
                            )}
                            <input
                                type="date"
                                value={fechaFiltro === 'indefinido' ? '' : fechaFiltro}
                                onChange={(e) => {
                                    setFechaFiltro(e.target.value);
                                    setVisibleDatesCount(5); // Reset pagination when filter changes
                                }}
                                onClick={(e) => {
                                    try {
                                        if (e.currentTarget.showPicker) e.currentTarget.showPicker();
                                    } catch (err) {
                                        console.log("Picker blocked or not supported", err);
                                    }
                                }}
                                className="header-date-input"
                                style={{
                                    color: fechaFiltro ? '#4a5568' : 'transparent',
                                    cursor: 'pointer'
                                }}
                            />
                        </div>

                        {fechaFiltro && (
                            <button
                                onClick={() => {
                                    setFechaFiltro('');
                                    setVisibleDatesCount(5); // Reset pagination when clearing filter
                                }}
                                className="header-clear-btn"
                                title="Limpiar filtro"
                            >
                                ✖
                            </button>
                        )}
                    </div>
                </div>

                {isPublicador && (
                    <div className="header-actions">
                        <button
                            className="header-btn header-btn-new"
                            onClick={() => setShowForm(true)}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                                <line x1="12" y1="5" x2="12" y2="19"></line>
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                            </svg>
                            Nueva
                        </button>
                    </div>
                )}
            </div>

            {fechaFiltro && fechaFiltro !== '' && (
                <div style={{
                    marginBottom: '20px',
                    padding: '10px 15px',
                    backgroundColor: '#e3f2fd',
                    borderRadius: '8px',
                    fontSize: '0.9rem',
                    color: '#1565c0',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    width: 'fit-content',
                    border: '1px solid #bbdefb'
                }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 6v6l4 2" />
                    </svg>
                    Mostrando publicaciones de: <strong>{fechaFiltro === 'indefinido' ? 'Fecha indefinida' : new Date(fechaFiltro + 'T00:00:00').toLocaleDateString('es-AR', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</strong>
                </div>
            )}









            {
                showForm && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 2000,
                        padding: '20px',
                        boxSizing: 'border-box'
                    }} onClick={(e) => {
                        if (e.target === e.currentTarget) setShowForm(false);
                    }}>
                        <form onSubmit={handleSubmit} style={{
                            backgroundColor: 'white',
                            padding: '25px',
                            borderRadius: '12px',
                            boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                            width: '100%',
                            maxWidth: '800px',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            position: 'relative'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '20px',
                                borderBottom: '1px solid #eee',
                                paddingBottom: '15px'
                            }}>
                                <h3 style={{ margin: 0, color: '#1a3b5d', fontSize: '1.25rem' }}>
                                    Nueva publicación para {tipoLabel(nuevaPublicacion.tipo)}
                                </h3>
                                <button
                                    type="button"
                                    onClick={() => setShowForm(false)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: '24px',
                                        lineHeight: '1',
                                        cursor: 'pointer',
                                        color: '#666',
                                        padding: '5px'
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    color: '#1a3b5d',
                                    fontWeight: '500'
                                }}>
                                    Plataforma
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '15px',
                                    flexWrap: 'wrap',
                                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                                }}>
                                    {['todas', 'facebook', 'instagram', 'tiktok'].map((platform) => (
                                        <label key={platform} style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            cursor: 'pointer'
                                        }}>
                                            <input
                                                type="radio"
                                                name="tipo"
                                                value={platform}
                                                checked={nuevaPublicacion.tipo === platform}
                                                onChange={(e) => setNuevaPublicacion({
                                                    ...nuevaPublicacion,
                                                    tipo: e.target.value
                                                })}
                                                style={{ margin: 0 }}
                                            />
                                            <span style={{ color: '#333' }}>{tipoLabel(platform)}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                            <div style={{ marginBottom: '20px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '10px',
                                    color: '#1a3b5d',
                                    fontWeight: '500'
                                }}>
                                    Estado Inicial
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '15px',
                                    flexWrap: 'wrap'
                                }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                        <input
                                            type="radio"
                                            name="estado"
                                            value="pendiente"
                                            checked={nuevaPublicacion.estado === 'pendiente'}
                                            onChange={(e) => setNuevaPublicacion({ ...nuevaPublicacion, estado: e.target.value })}
                                            style={{ margin: 0 }}
                                        />
                                        <span style={{ color: '#333' }}>Pendiente</span>
                                    </label>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                        <input
                                            type="radio"
                                            name="estado"
                                            value="confirmado"
                                            checked={nuevaPublicacion.estado === 'confirmado'}
                                            onChange={(e) => setNuevaPublicacion({ ...nuevaPublicacion, estado: e.target.value })}
                                            style={{ margin: 0 }}
                                        />
                                        <span style={{ color: '#333' }}>Confirmado</span>
                                    </label>
                                </div>
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    color: '#1a3b5d',
                                    fontWeight: '500'
                                }}>
                                    Texto de la publicación
                                </label>
                                <textarea
                                    value={nuevaPublicacion.contenido}
                                    onChange={(e) => setNuevaPublicacion({
                                        ...nuevaPublicacion,
                                        contenido: e.target.value
                                    })}
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        borderRadius: '6px',
                                        border: '1px solid #ced4da',
                                        minHeight: '100px',
                                        resize: 'vertical'
                                    }}
                                />
                            </div>

                            <div style={{ marginBottom: '15px' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '5px',
                                    color: '#1a3b5d',
                                    fontWeight: '500'
                                }}>
                                    URLs de imágenes
                                </label>

                                {/* Área de drag and drop para subir archivos */}
                                <div
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                    onClick={() => fileInputRef.current?.click()}
                                    style={{
                                        border: `2px dashed ${isDragOver ? '#1a3b5d' : '#ced4da'}`,
                                        borderRadius: '8px',
                                        padding: '20px',
                                        textAlign: 'center',
                                        cursor: 'pointer',
                                        backgroundColor: isDragOver ? '#f0f4f8' : '#f8f9fa',
                                        marginBottom: '15px',
                                        transition: 'all 0.3s ease'
                                    }}
                                >
                                    <div style={{ color: '#666', marginBottom: '10px' }}>
                                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" style={{ margin: '0 auto 10px' }}>
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                            <polyline points="7,10 12,15 17,10" />
                                            <line x1="12" y1="15" x2="12" y2="3" />
                                        </svg>
                                    </div>
                                    <p style={{ margin: '0 0 5px 0', color: '#333', fontWeight: '500' }}>
                                        Arrastra y suelta archivos aquí o haz clic para seleccionar
                                    </p>
                                    <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                                        Soporta imágenes y videos
                                    </p>
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        multiple
                                        accept="image/*,video/*"
                                        onChange={handleFileInputChange}
                                        style={{ display: 'none' }}
                                    />
                                </div>

                                {/* Mostrar archivos en proceso de subida */}
                                {uploadingFiles.length > 0 && (
                                    <div style={{ marginBottom: '15px' }}>
                                        <h4 style={{ margin: '0 0 10px 0', color: '#1a3b5d' }}>Subiendo archivos:</h4>
                                        {uploadingFiles.map((item, index) => (
                                            <div key={index} style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px',
                                                padding: '10px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '6px',
                                                marginBottom: '5px'
                                            }}>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontWeight: '500' }}>{item.file.name}</div>
                                                    <div style={{ fontSize: '12px', color: '#666' }}>
                                                        {item.status === 'uploading' && 'Subiendo...'}
                                                        {item.status === 'completed' && '✅ Completado'}
                                                        {item.status === 'error' && `❌ Error: ${item.error}`}
                                                    </div>
                                                </div>
                                                {item.status === 'uploading' && (
                                                    <div style={{
                                                        width: '20px',
                                                        height: '20px',
                                                        border: '2px solid #f3f3f3',
                                                        borderTop: '2px solid #1a3b5d',
                                                        borderRadius: '50%',
                                                        animation: 'spin 1s linear infinite'
                                                    }}></div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                )}

                                <div style={{ display: 'flex', flexDirection: window.innerWidth <= 600 ? 'column' : 'row', gap: '10px', marginBottom: '10px' }}>
                                    <input
                                        type="url"
                                        value={nuevaPublicacion.contenidoUrl}
                                        onChange={handleContenidoChange}
                                        placeholder="https://... (o sube archivos arriba)"
                                        style={{
                                            flex: 1,
                                            padding: '10px',
                                            borderRadius: '6px',
                                            border: '1px solid #ced4da',
                                            marginBottom: window.innerWidth <= 600 ? '10px' : 0
                                        }}
                                    />
                                    <button
                                        type="button"
                                        onClick={handleAgregarUrl}
                                        style={{
                                            padding: '10px 20px',
                                            backgroundColor: '#1a3b5d',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            width: window.innerWidth <= 600 ? '100%' : undefined
                                        }}
                                    >
                                        Agregar
                                    </button>
                                </div>
                                {nuevaPublicacion.urlsImagenes.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        <h4 style={{ margin: '0 0 10px 0', color: '#1a3b5d' }}>URLs agregadas:</h4>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {nuevaPublicacion.urlsImagenes.map((url, index) => (
                                                <div key={index} style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    padding: '10px',
                                                    backgroundColor: '#f8f9fa',
                                                    borderRadius: '6px'
                                                }}>
                                                    <div style={{ flex: 1, wordBreak: 'break-all' }}>
                                                        {url}
                                                        {isCloudinaryUrl(url) && (
                                                            <span style={{
                                                                marginLeft: '8px',
                                                                fontSize: '12px',
                                                                color: '#28a745',
                                                                fontWeight: '500'
                                                            }}>
                                                                â˜ï¸ Cloudinary
                                                            </span>
                                                        )}
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleEliminarUrl(index)}
                                                        style={{
                                                            padding: '5px 10px',
                                                            backgroundColor: '#e53e3e',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        Eliminar
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div style={{
                                display: 'grid',
                                gridTemplateColumns: window.innerWidth <= 600 ? '1fr' : '1fr 1fr',
                                gap: '15px',
                                marginBottom: '15px'
                            }}>
                                <div>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            color: '#1a3b5d',
                                            fontWeight: '500'
                                        }}>
                                            Fecha de publicación
                                        </label>
                                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                            <input
                                                type="date"
                                                value={nuevaPublicacion.fechaPublicacion}
                                                onChange={(e) => setNuevaPublicacion({
                                                    ...nuevaPublicacion,
                                                    fechaPublicacion: e.target.value
                                                })}
                                                onClick={(e) => {
                                                    try {
                                                        if (e.currentTarget.showPicker) e.currentTarget.showPicker();
                                                    } catch (err) {
                                                        console.log("Picker blocked or not supported", err);
                                                    }
                                                }}
                                                style={{
                                                    width: '100%',
                                                    padding: '8px',
                                                    borderRadius: '6px',
                                                    border: '1px solid #ced4da',
                                                    cursor: 'pointer'
                                                }}
                                                disabled={nuevaPublicacion.fechaPublicacion === 'indefinido'}
                                            />
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '0.95em', color: '#1a3b5d' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={nuevaPublicacion.fechaPublicacion === 'indefinido'}
                                                    onChange={e => setNuevaPublicacion({
                                                        ...nuevaPublicacion,
                                                        fechaPublicacion: e.target.checked ? 'indefinido' : ''
                                                    })}
                                                />
                                                Indefinido
                                            </label>
                                        </div>
                                    </div>
                                <div>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '5px',
                                            color: '#1a3b5d',
                                            fontWeight: '500'
                                        }}>
                                            Hora de publicación
                                        </label>
                                        <input
                                            type="time"
                                            value={nuevaPublicacion.horaPublicacion}
                                            onChange={(e) => setNuevaPublicacion({
                                                ...nuevaPublicacion,
                                                horaPublicacion: e.target.value
                                            })}
                                            required={nuevaPublicacion.fechaPublicacion !== 'indefinido'}
                                            disabled={nuevaPublicacion.fechaPublicacion === 'indefinido'}
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                borderRadius: '6px',
                                                border: '1px solid #ced4da'
                                            }}
                                        />
                                    </div>
                            </div>

                            <button
                                type="submit"
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#1a3b5d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '1rem',
                                    width: window.innerWidth <= 600 ? '100%' : undefined,
                                    marginTop: window.innerWidth <= 600 ? '10px' : 0
                                }}
                            >
                                Publicar
                            </button>
                        </form>
                    </div>
                )
            }

            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '30px',
                marginTop: '20px'
            }}>
                {(() => {
                    const now = new Date();
                    now.setHours(0, 0, 0, 0); // Resetear la hora a 00:00:00 para comparar solo fechas locales (Hoy)

                    const filteredPublications = publicaciones.filter(pub => {
                        // Filtro por tipo
                        const tipoMatch = tipoSeleccionado === 'todas' || pub.tipo === tipoSeleccionado || pub.tipo === 'todas';

                        // Filtro por fecha específica (si está seleccionada)
                        if (fechaFiltro && fechaFiltro !== '') {
                            const fechaPublicacion = pub.fechaPublicacion || '';

                            if (fechaFiltro === 'indefinido') {
                                // Mostrar publicaciones sin fecha o con fecha vacía o explícitamente indefinido
                                return tipoMatch && (fechaPublicacion === '' || fechaPublicacion === 'indefinido' || !fechaPublicacion);
                            } else {
                                // Extraer la fecha válida del formato "undefined-undefined-YYYY-MM-DD" o usar la fecha completa
                                let fechaLimpia = fechaPublicacion;
                                if (fechaPublicacion.includes('undefined-undefined-')) {
                                    fechaLimpia = fechaPublicacion.replace('undefined-undefined-', '');
                                }

                                // Comparar fechas en formato ISO (YYYY-MM-DD)
                                return tipoMatch && fechaLimpia === fechaFiltro;
                            }
                        }

                        return tipoMatch;
                    });

                    const stateFilteredPublications = filteredPublications.filter(pub => {
                        // Si es publicador, mostrar todas las publicaciones incluyendo las borradas
                        if (isPublicador) {
                            return true;
                        }
                        // Para otros tipos, aplicar el filtro de estado
                        if (!isAdmin) {
                            return pub.estado === 'confirmado';
                        }
                        // Para admin, mostrar todo excepto borradas
                        return pub.estado !== 'borrado';
                    });

                    const otrasPublicaciones = stateFilteredPublications;

                    // Función para ordenar publicaciones: primero pendientes, luego confirmadas, y por fecha (recientes primero)
                    const sortPublications = (a, b) => {
                        const statusPriority = { 'pendiente': 1, 'confirmado': 2 };
                        const priorityA = statusPriority[a.estado] || 99;
                        const priorityB = statusPriority[b.estado] || 99;

                        if (priorityA !== priorityB) {
                            return priorityA - priorityB;
                        }

                        // Por fecha de creación/actualización (recientes primero)
                        const dateA = a.fecha ? new Date(a.fecha) : new Date(0);
                        const dateB = b.fecha ? new Date(b.fecha) : new Date(0);
                        return dateB - dateA;
                    };

                    // Agrupar las otras publicaciones por fecha
                    const groupedPublications = otrasPublicaciones.reduce((acc, pub) => {
                        // Si la fecha es indefinida ('' o null), usar 'indefinido' como clave
                        const fecha = pub.fechaPublicacion ? pub.fechaPublicacion : 'indefinido';
                        if (!acc[fecha]) {
                            acc[fecha] = [];
                        }
                        acc[fecha].push(pub);
                        return acc;
                    }, {});

                    // Ordenar las publicaciones dentro de cada grupo de fecha
                    Object.keys(groupedPublications).forEach(fecha => {
                        groupedPublications[fecha].sort(sortPublications);
                    });

                    // Ordenar fechas: primero 'indefinido', luego fechas normales
                    const sortedDates = Object.keys(groupedPublications)
                        .sort((a, b) => {
                            if (a === 'indefinido') return -1;
                            if (b === 'indefinido') return 1;
                            // Prevenir problemas de timezone forzando hora local
                            return new Date(a + 'T00:00:00') - new Date(b + 'T00:00:00');
                        });

                    // Para publicaciones normales, mantener la lógica de futuras y pasadas
                    // Si hay un filtro de fecha específico, mostrar todas las publicaciones sin separar en pasadas
                    let futureDates, pastDates;
                    if (fechaFiltro && fechaFiltro !== 'indefinido') {
                        // Cuando hay filtro de fecha, mostrar todas las fechas como "futuras" para evitar el botón de pasadas
                        futureDates = sortedDates.filter(date => date !== 'indefinido');
                        pastDates = [];
                    } else {
                        // Lógica normal cuando no hay filtro de fecha específico
                        futureDates = sortedDates.filter(date => {
                            if (date === 'indefinido') return false;
                            const dateObj = new Date(date + 'T00:00:00'); // Evitar offset
                            dateObj.setHours(0, 0, 0, 0);
                            return dateObj >= now;
                        });
                        pastDates = sortedDates.filter(date => {
                            if (date === 'indefinido') return false;
                            const dateObj = new Date(date + 'T00:00:00'); // Evitar offset
                            dateObj.setHours(0, 0, 0, 0);
                            return dateObj < now;
                        });
                        // Ordenar las fechas pasadas de más reciente a más antigua
                        pastDates = pastDates.sort((a, b) => new Date(b + 'T00:00:00') - new Date(a + 'T00:00:00'));
                    }

                    // Después de obtener sortedDates, futureDates, pastDates:
                    const indefinidoDates = sortedDates.filter(date => date === 'indefinido');
                    const normalFutureDates = futureDates.filter(date => date !== 'indefinido');

                    return (
                        <>
                            {/* Renderizado de listas de publicaciones */}
                            {(
                                <>
                                    {/* Mostrar publicaciones con fecha indefinida primero */}
                                    {indefinidoDates.length > 0 && (
                                        <div>
                                            <h3 className="publications-date-header" style={{
                                                color: '#1a3b5d',
                                                marginBottom: '15px',
                                                padding: '10px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '6px',
                                                fontSize: '1.1rem'
                                            }}>
                                                Fecha: Indefinido
                                            </h3>
                                            <div style={{
                                                display: 'flex',
                                                gap: '15px',
                                                overflowX: 'auto',
                                                scrollbarWidth: 'thin',
                                                WebkitOverflowScrolling: 'touch',
                                                msOverflowStyle: 'none',
                                                borderRadius: '8px',
                                            }} className="publications-scroll">
                                                {groupedPublications['indefinido'].map((publicacion) => (
                                                    <div
                                                        key={publicacion.id}
                                                        className="publication-card"
                                                        onClick={() => handleVerPublicacion(publicacion)}
                                                        style={{
                                                            width: '100%',
                                                            position: 'relative',
                                                            border: tieneCambiosNoVistos(publicacion) ? '2px solid #4299e1' : 'none'
                                                        }}
                                                    >
                                                        {tieneCambiosNoVistos(publicacion) && (
                                                            <div className="new-indicator" style={{
                                                                position: 'absolute',
                                                                top: '10px',
                                                                right: '10px',
                                                                backgroundColor: '#4299e1',
                                                                color: 'white',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px',
                                                                fontSize: '0.7rem',
                                                                zIndex: 1,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '4px'
                                                            }}>
                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="M12 6v6l4 2" />
                                                                </svg>
                                                                Nuevo
                                                            </div>
                                                        )}
                                                        <div className="publication-image-container">
                                                            {(publicacion.contenidoUrl || (publicacion.urlsImagenes && publicacion.urlsImagenes.length > 0)) ? (
                                                                renderContenido(publicacion)
                                                            ) : (
                                                                <div className="publication-content-placeholder">
                                                                    Sin contenido multimedia
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="publication-content" style={{
                                                            fontFamily: 'Segoe UI, Roboto, Arial, sans-serif',
                                                            fontWeight: 400,
                                                            fontSize: '1.18rem',
                                                            color: '#222'
                                                        }}>
                                                            <div className="publication-badges">
                                                                <span className="publication-badge" style={{
                                                                    backgroundColor: tipoColorFondo(publicacion.tipo),
                                                                    color: tipoColorTexto(publicacion.tipo),
                                                                    border: `2px solid ${tipoColorBorde(publicacion.tipo)}`
                                                                }}>
                                                                    {tipoLabel(publicacion.tipo)}
                                                                </span>
                                                                <span className="publication-badge" style={{
                                                                    backgroundColor: estadoColorFondo(publicacion.estado),
                                                                    color: estadoColorTexto(publicacion.estado),
                                                                    border: `2px solid ${estadoColorBorde(publicacion.estado)}`
                                                                }}>
                                                                    {estadoLabel(publicacion.estado)}
                                                                </span>
                                                            </div>
                                                            <div className="publication-date">
                                                                {publicacion.fechaPublicacion && publicacion.fechaPublicacion !== 'indefinido'
                                                                    ? `${obtenerNombreDia(publicacion.fechaPublicacion)}, ${formatearFechaArgentina(publicacion.fechaPublicacion)}${publicacion.horaPublicacion ? ' - ' + publicacion.horaPublicacion : ''}`
                                                                    : 'Indefinido'}
                                                            </div>
                                                            <div className="publication-preview" style={{
                                                                marginTop: '8px',
                                                                color: '#222',
                                                                fontSize: '1.15rem',
                                                                lineHeight: '1.5',
                                                                fontWeight: 500,
                                                                fontFamily: 'Segoe UI, Roboto, Arial, sans-serif',
                                                                fontStyle: 'italic'
                                                            }}>
                                                                {truncarTexto(publicacion.contenido, 80)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {/* Publicaciones futuras y actuales - con paginación */}
                                    {normalFutureDates.slice(0, visibleDatesCount).map(fecha => (
                                        <div key={fecha}>
                                            <h3 className="publications-date-header" style={{
                                                color: '#1a3b5d',
                                                marginBottom: '15px',
                                                padding: '10px',
                                                backgroundColor: '#f8f9fa',
                                                borderRadius: '6px',
                                                fontSize: '1.1rem'
                                            }}>
                                                {fecha === 'indefinido'
                                                    ? 'Fecha: Indefinido'
                                                    : `${formatearFechaArgentina(fecha)} - ${obtenerNombreDia(fecha)}${esHoy(fecha) ? ' (Hoy)' : ''}`}
                                            </h3>
                                            <div style={{
                                                display: 'flex',
                                                gap: '15px',
                                                overflowX: 'auto',
                                                scrollbarWidth: 'thin',
                                                WebkitOverflowScrolling: 'touch',
                                                msOverflowStyle: 'none',
                                                backgroundColor: esHoy(fecha) ? ' #7e91d3 ' : 'transparent',
                                                borderRadius: '8px',
                                                padding: esHoy(fecha) ? '15px' : '10px 0'
                                            }} className="publications-scroll">
                                                {groupedPublications[fecha].map((publicacion) => (
                                                    <div
                                                        key={publicacion.id}
                                                        className="publication-card"
                                                        onClick={() => handleVerPublicacion(publicacion)}
                                                        style={{
                                                            width: '100%',
                                                            position: 'relative',
                                                            border: (typeof tieneCambiosNoVistos === 'function' && tieneCambiosNoVistos(publicacion)) ? '2px solid #4299e1' : 'none'
                                                        }}
                                                    >
                                                        {typeof tieneCambiosNoVistos === 'function' && tieneCambiosNoVistos(publicacion) && (
                                                            <div className="new-indicator" style={{
                                                                position: 'absolute',
                                                                top: '10px',
                                                                right: '10px',
                                                                backgroundColor: '#4299e1',
                                                                color: 'white',
                                                                padding: '4px 8px',
                                                                borderRadius: '12px',
                                                                fontSize: '0.7rem',
                                                                zIndex: 1,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '4px'
                                                            }}>
                                                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                    <circle cx="12" cy="12" r="10" />
                                                                    <path d="M12 6v6l4 2" />
                                                                </svg>
                                                                Nuevo
                                                            </div>
                                                        )}
                                                        <div className="publication-image-container">
                                                            {(publicacion.contenidoUrl || (publicacion.urlsImagenes && publicacion.urlsImagenes.length > 0)) ? (
                                                                renderContenido(publicacion)
                                                            ) : (
                                                                <div className="publication-content-placeholder">
                                                                    Sin contenido multimedia
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="publication-content" style={{
                                                            fontFamily: 'Segoe UI, Roboto, Arial, sans-serif',
                                                            fontWeight: 400,
                                                            fontSize: '1.18rem',
                                                            color: '#222'
                                                        }}>
                                                            <div className="publication-badges">
                                                                <span className="publication-badge" style={{
                                                                    backgroundColor: tipoColorFondo(publicacion.tipo),
                                                                    color: tipoColorTexto(publicacion.tipo),
                                                                    border: `2px solid ${tipoColorBorde(publicacion.tipo)}`
                                                                }}>
                                                                    {tipoLabel(publicacion.tipo)}
                                                                </span>
                                                                <span className="publication-badge" style={{
                                                                    backgroundColor: estadoColorFondo(publicacion.estado),
                                                                    color: estadoColorTexto(publicacion.estado),
                                                                    border: `2px solid ${estadoColorBorde(publicacion.estado)}`
                                                                }}>
                                                                    {estadoLabel(publicacion.estado)}
                                                                </span>
                                                            </div>
                                                            <div className="publication-date">
                                                                {publicacion.fechaPublicacion && publicacion.fechaPublicacion !== 'indefinido'
                                                                    ? `${obtenerNombreDia(publicacion.fechaPublicacion)}, ${formatearFechaArgentina(publicacion.fechaPublicacion)}${publicacion.horaPublicacion ? ' - ' + publicacion.horaPublicacion : ''}`
                                                                    : 'Indefinido'}
                                                            </div>
                                                            <div className="publication-preview" style={{
                                                                marginTop: '8px',
                                                                color: '#222',
                                                                fontSize: '1.15rem',
                                                                lineHeight: '1.5',
                                                                fontWeight: 500,
                                                                fontFamily: 'Segoe UI, Roboto, Arial, sans-serif',
                                                                fontStyle: 'italic'
                                                            }}>
                                                                {truncarTexto(publicacion.contenido, 80)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}

                                    {/* Load More button for future dates */}
                                    {normalFutureDates.length > visibleDatesCount && (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px'
                                        }}>
                                            <button
                                                onClick={() => setVisibleDatesCount(prev => prev + DATES_PER_PAGE)}
                                                style={{
                                                    padding: '12px 24px',
                                                    backgroundColor: '#1a3b5d',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    cursor: 'pointer',
                                                    fontSize: '0.95rem',
                                                    fontWeight: 500,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseOver={e => e.currentTarget.style.backgroundColor = '#2c4f7c'}
                                                onMouseOut={e => e.currentTarget.style.backgroundColor = '#1a3b5d'}
                                            >
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <polyline points="6 9 12 15 18 9"></polyline>
                                                </svg>
                                                Ver más fechas ({normalFutureDates.length - visibleDatesCount} restantes)
                                            </button>
                                        </div>
                                    )}

                                    {/* Botón para mostrar/ocultar publicaciones pasadas - solo mostrar si no son historias diarias */}
                                    {pastDates.length > 0 && (
                                        <div style={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            backgroundColor: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}>
                                            <button
                                                onClick={() => preserveScroll(() => setShowPastPublications(!showPastPublications))}
                                                style={{
                                                    width: '100%',
                                                    padding: '10px',
                                                    backgroundColor: '#f8f9fa',
                                                    border: '1px solid #ced4da',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    color: '#1a3b5d'
                                                }}
                                            >
                                                <span>Publicaciones Pasadas</span>
                                                <span>{showPastPublications ? '▼' : '▶'}</span>
                                            </button>

                                            {showPastPublications && (
                                                <div style={{ marginTop: '20px' }}>
                                                    {pastDates.map(fecha => (
                                                        <div key={fecha}>
                                                            <h3 className="publications-date-header" style={{
                                                                color: '#1a3b5d',
                                                                marginBottom: '15px',
                                                                padding: '10px',
                                                                backgroundColor: '#f8f9fa',
                                                                borderRadius: '6px',
                                                                fontSize: '1.1rem'
                                                            }}>
                                                                {fecha === 'indefinido'
                                                                    ? 'Fecha: Indefinido'
                                                                    : `${formatearFechaArgentina(fecha)} - ${obtenerNombreDia(fecha)}${esHoy(fecha) ? ' (Hoy)' : ''}`}
                                                            </h3>
                                                            <div style={{
                                                                display: 'flex',
                                                                gap: '15px',
                                                                overflowX: 'auto',
                                                                scrollbarWidth: 'thin',
                                                                WebkitOverflowScrolling: 'touch',
                                                                msOverflowStyle: 'none',
                                                                backgroundColor: esHoy(fecha) ? ' #7e91d3 ' : 'transparent',
                                                                borderRadius: '8px',
                                                                padding: esHoy(fecha) ? '15px' : '10px 0'
                                                            }} className="publications-scroll">
                                                                {groupedPublications[fecha].map((publicacion) => (
                                                                    <div
                                                                        key={publicacion.id}
                                                                        className="publication-card"
                                                                        onClick={() => handleVerPublicacion(publicacion)}
                                                                        style={{
                                                                            width: '100%',
                                                                            position: 'relative'
                                                                        }}
                                                                    >
                                                                        <div className="publication-image-container">
                                                                            {(publicacion.contenidoUrl || (publicacion.urlsImagenes && publicacion.urlsImagenes.length > 0)) ? (
                                                                                renderContenido(publicacion)
                                                                            ) : (
                                                                                <div className="publication-content-placeholder">
                                                                                    Sin contenido multimedia
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                        <div className="publication-content" style={{
                                                                            fontFamily: 'Segoe UI, Roboto, Arial, sans-serif',
                                                                            fontWeight: 400,
                                                                            fontSize: '1.18rem',
                                                                            color: '#222'
                                                                        }}>
                                                                            <div className="publication-badges">

                                                                                <span className="publication-badge" style={{
                                                                                    backgroundColor: tipoColorFondo(publicacion.tipo),
                                                                                    color: tipoColorTexto(publicacion.tipo),
                                                                                    border: `2px solid ${tipoColorBorde(publicacion.tipo)}`
                                                                                }}>
                                                                                    {tipoLabel(publicacion.tipo)}
                                                                                </span>
                                                                                <span className="publication-badge" style={{
                                                                                    backgroundColor: estadoColorFondo(publicacion.estado),
                                                                                    color: estadoColorTexto(publicacion.estado),
                                                                                    border: `2px solid ${estadoColorBorde(publicacion.estado)}`
                                                                                }}>
                                                                                    {estadoLabel(publicacion.estado)}
                                                                                </span>
                                                                            </div>
                                                                            <div className="publication-date">
                                                                                {publicacion.fechaPublicacion && publicacion.fechaPublicacion !== 'indefinido'
                                                                                    ? `${obtenerNombreDia(publicacion.fechaPublicacion)}, ${formatearFechaArgentina(publicacion.fechaPublicacion)}${publicacion.horaPublicacion ? ' - ' + publicacion.horaPublicacion : ''}`
                                                                                    : 'Indefinido'}
                                                                            </div>
                                                                            <div className="publication-preview" style={{
                                                                                marginTop: '8px',
                                                                                color: '#222',
                                                                                fontSize: '1.15rem',
                                                                                lineHeight: '1.5',
                                                                                fontWeight: 500,
                                                                                fontFamily: 'Segoe UI, Roboto, Arial, sans-serif',
                                                                                fontStyle: 'italic'
                                                                            }}>
                                                                                {truncarTexto(publicacion.contenido, 80)}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )}

                                </>
                            )}
                        </>
                    );
                })()}
            </div>

            {showModal && <Modal />}
            {/* Mensaje de confirmación visual */}
            {
                mensajeConfirmacion && (
                    <div style={{
                        position: 'fixed',
                        top: '30px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#38a169',
                        color: 'white',
                        padding: '16px 32px',
                        borderRadius: '8px',
                        fontWeight: 600,
                        fontSize: '1.1rem',
                        zIndex: 3000,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.12)'
                    }}>
                        {mensajeConfirmacion}
                    </div>
                )
            }

            {renderPreviewModal()}


        </div >
    );
}

export default Pendientes;

// CSS adicional para ocultar el filtro de fecha en móviles
const cssContent = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    @media (max-width: 768px) {
        .date-filter-desktop {
            display: none !important;
        }
        .view-toggle-desktop {
            display: none !important;
        }
    }
    @media (min-width: 769px) {
        .date-filter-desktop {
            display: block !important;
        }
        .view-toggle-desktop {
            display: block !important;
        }
    }
    
    @media (max-width: 600px) {
        /* Actions */
        .publication-separator {
            display: none !important;
        }
        .publication-actions-group {
            display: contents !important;
            margin-left: 0 !important;
        }
        .publication-action-btn {
            padding: 4px 0 !important;
            font-size: 0.7rem !important;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 36px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            border-radius: 4px !important;
        }
        .publication-actions-container {
            display: grid !important;
            grid-template-columns: repeat(4, 1fr) !important;
            gap: 4px !important;
            padding: 8px 8px !important;
        }
        .publication-actions-group > .publication-action-btn {
            font-weight: 700 !important;
        }
        .publication-actions-container > :nth-last-child(1),
        .publication-actions-container > :nth-last-child(2) {
             grid-column: span 2;
        }
        .publication-actions-container > :nth-child(6) {
             grid-column: auto;
        }

        /* Modal Content Responsive Tweaks */
        .modal-content-container {
            padding: 16px !important; /* Menor padding del contenedor */
        }
        .modal-text-content {
            font-size: 0.95rem !important; /* Texto un pelín más chico */
            line-height: 1.5 !important;
            margin-bottom: 20px !important;
        }
        .modal-meta-row {
            margin-bottom: 16px !important;
            gap: 8px !important;
            font-size: 0.8rem !important;
        }
        .modal-copy-btn {
            padding: 4px 10px !important;
            font-size: 0.75rem !important;
        }

        /* Comments Responsive Tweaks */
        .comments-section {
            padding-top: 16px !important;
        }
        .comment-form {
            display: flex !important;
            flex-direction: column !important; /* Stack input and button */
            gap: 8px !important;
        }
        .comment-input {
            width: 100% !important;
            font-size: 16px !important; /* Prevent zoom on mobile inputs */
        }
        .comment-submit-btn {
            width: 100% !important;
            padding: 10px !important;
            border-radius: 12px !important; /* Slightly less rounded for full width feels better */
        }
        .comment-item {
            gap: 8px !important;
        }
        .comment-header {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 2px !important;
        }
        .comment-header span:last-child {
            font-size: 0.7rem !important; /* Date slightly smaller */
        }

        /* Views & History Responsive Tweaks */
        .views-item {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 2px !important;
        }
        .views-item span:last-child {
            font-size: 0.75rem !important;
            color: #a0aec0 !important;
        }
        .history-bottom-row {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 2px !important;
        }
        .history-bottom-row span:last-child {
            font-size: 0.75rem !important;
        }

        /* --- MOBILE UI IMPROVEMENTS --- */
        
        /* 1. Edge-to-Edge Design */
        .publications-container {
            padding: 0 !important;
            max-width: 100% !important;
        }
        .publication-card {
            border-radius: 0 !important;
            border-left: none !important;
            border-right: none !important;
            border-top: none !important;
            margin-bottom: 0 !important;
            box-shadow: none !important;
            border-bottom: 1px solid #e2e8f0 !important;
        }
        .publication-image-container img, 
        .publication-image-container video {
            border-radius: 0 !important;
        }

        /* 2. Compact Headers */
        .publications-date-header {
            font-size: 0.9rem !important;
            padding: 6px 12px !important;
            background-color: #f7fafc !important;
            margin-bottom: 0 !important;
            border-radius: 0 !important;
            border-bottom: 1px solid #edf2f7 !important;
            color: #4a5568 !important;
            font-weight: 600 !important;
            position: sticky !important;
            top: 70px !important; /* Ajustado para dar aire respecto al navbar */
            z-index: 900 !important;
            box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
        }
        

    }
`;

let styleEl = document.head.querySelector('style[data-date-filter]');
if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.setAttribute('data-date-filter', 'true');
    document.head.appendChild(styleEl);
}
styleEl.textContent = cssContent;
